const words = [
  {
    "name": "best cbd dog treats",
    "slug": "best-cbd-dog-treats"
  },
  {
    "name": "best cbd treats for dogs",
    "slug": "best-cbd-treats-for-dogs"
  },
  {
    "name": "cbd dog health reviews",
    "slug": "cbd-dog-health-reviews"
  },
  {
    "name": "cbd oil for dogs reviews",
    "slug": "cbd-oil-for-dogs-reviews"
  },
  {
    "name": "dog cbd calming chews",
    "slug": "dog-cbd-calming-chews"
  },
  {
    "name": "full spectrum cbd oil for dogs",
    "slug": "full-spectrum-cbd-oil-for-dogs"
  },
  {
    "name": "best dog cbd chews",
    "slug": "best-dog-cbd-chews"
  },
  {
    "name": "cbd benefits for dogs",
    "slug": "cbd-benefits-for-dogs"
  },
  {
    "name": "cbd oil for dogs dose calculator",
    "slug": "cbd-oil-for-dogs-dose-calculator"
  },
  {
    "name": "cbd oil dosage for dogs",
    "slug": "cbd-oil-dosage-for-dogs"
  },
  {
    "name": "full spectrum cbd for dogs",
    "slug": "full-spectrum-cbd-for-dogs"
  },
  {
    "name": "organic cbd for dogs",
    "slug": "organic-cbd-for-dogs"
  },
  {
    "name": "pet cbd treats for dogs",
    "slug": "pet-cbd-treats-for-dogs"
  },
  {
    "name": "dog cbd treats for anxiety",
    "slug": "dog-cbd-treats-for-anxiety"
  },
  {
    "name": "cbd chews for dog anxiety",
    "slug": "cbd-chews-for-dog-anxiety"
  },
  {
    "name": "cbd dog chews for anxiety",
    "slug": "cbd-dog-chews-for-anxiety"
  },
  {
    "name": "cbd for dogs afraid of storms",
    "slug": "cbd-for-dogs-afraid-of-storms"
  },
  {
    "name": "natural dog anxiety",
    "slug": "natural-dog-anxiety"
  },
  {
    "name": "dog calming supplements",
    "slug": "dog-calming-supplements"
  },
  {
    "name": "anxiety relief dogs",
    "slug": "anxiety-relief-dogs"
  },
  {
    "name": "managing dog anxiety",
    "slug": "managing-dog-anxiety"
  },
  {
    "name": "calming sprays dogs",
    "slug": "calming-sprays-dogs"
  },
  {
    "name": "anxiety collars dogs",
    "slug": "anxiety-collars-dogs"
  },
  {
    "name": "stress-free dogs",
    "slug": "stress-free-dogs"
  },
  {
    "name": "calming dog beds",
    "slug": "calming-dog-beds"
  },
  {
    "name": "herbal dog remedies",
    "slug": "herbal-dog-remedies"
  },
  {
    "name": "dog anxiety management",
    "slug": "dog-anxiety-management"
  },
  {
    "name": "calming dog toys",
    "slug": "calming-dog-toys"
  },
  {
    "name": "soothing dog collars",
    "slug": "soothing-dog-collars"
  },
  {
    "name": "dog stress management",
    "slug": "dog-stress-management"
  },
  {
    "name": "anxious dog symptoms",
    "slug": "anxious-dog-symptoms"
  },
  {
    "name": "dog calming chews",
    "slug": "dog-calming-chews"
  },
  {
    "name": "dog anxiety treatments",
    "slug": "dog-anxiety-treatments"
  },
  {
    "name": "anxiety solutions dogs",
    "slug": "anxiety-solutions-dogs"
  },
  {
    "name": "soothing chews dogs",
    "slug": "soothing-chews-dogs"
  },
  {
    "name": "calming routines dogs",
    "slug": "calming-routines-dogs"
  },
  {
    "name": "stress management dogs",
    "slug": "stress-management-dogs"
  },
  {
    "name": "relaxing chews dogs",
    "slug": "relaxing-chews-dogs"
  },
  {
    "name": "calming toys dogs",
    "slug": "calming-toys-dogs"
  },
  {
    "name": "anxiety sprays dogs",
    "slug": "anxiety-sprays-dogs"
  },
  {
    "name": "soothing dog beds",
    "slug": "soothing-dog-beds"
  },
  {
    "name": "dog anxiety relief",
    "slug": "dog-anxiety-relief"
  },
  {
    "name": "calming dog sprays",
    "slug": "calming-dog-sprays"
  },
  {
    "name": "dog stress-relief sprays",
    "slug": "dog-stress-relief-sprays"
  },
  {
    "name": "natural dog stress",
    "slug": "natural-dog-stress"
  },
  {
    "name": "calming activities dogs",
    "slug": "calming-activities-dogs"
  },
  {
    "name": "soothing dog solutions",
    "slug": "soothing-dog-solutions"
  },
  {
    "name": "calming oils dogs",
    "slug": "calming-oils-dogs"
  },
  {
    "name": "anxiety vests dogs",
    "slug": "anxiety-vests-dogs"
  },
  {
    "name": "anxiety treatments dogs",
    "slug": "anxiety-treatments-dogs"
  },
  {
    "name": "calming beds dogs",
    "slug": "calming-beds-dogs"
  },
  {
    "name": "dog-friendly calming chews",
    "slug": "dog-friendly-calming-chews"
  },
  {
    "name": "dog-friendly calming products",
    "slug": "dog-friendly-calming-products"
  },
  {
    "name": "dog stress-free solutions",
    "slug": "dog-stress-free-solutions"
  },
  {
    "name": "dog calming collars",
    "slug": "dog-calming-collars"
  },
  {
    "name": "herbal sprays dogs",
    "slug": "herbal-sprays-dogs"
  },
  {
    "name": "dog-friendly soothing collars",
    "slug": "dog-friendly-soothing-collars"
  },
  {
    "name": "natural dog sprays",
    "slug": "natural-dog-sprays"
  },
  {
    "name": "stress-free dog environments",
    "slug": "stress-free-dog-environments"
  },
  {
    "name": "natural dog anxiety solutions",
    "slug": "natural-dog-anxiety-solutions"
  },
  {
    "name": "natural remedies for dog anxiety",
    "slug": "natural-remedies-for-dog-anxiety"
  },
  {
    "name": "calming supplements for anxious dogs",
    "slug": "calming-supplements-for-anxious-dogs"
  },
  {
    "name": "managing stress in dogs naturally",
    "slug": "managing-stress-in-dogs-naturally"
  },
  {
    "name": "herbal remedies for anxious dogs",
    "slug": "herbal-remedies-for-anxious-dogs"
  },
  {
    "name": "anxiety relief products for dogs",
    "slug": "anxiety-relief-products-for-dogs"
  },
  {
    "name": "calming sprays for dog anxiety",
    "slug": "calming-sprays-for-dog-anxiety"
  },
  {
    "name": "natural solutions for dog anxiety",
    "slug": "natural-solutions-for-dog-anxiety"
  },
  {
    "name": "best remedies for anxious dogs",
    "slug": "best-remedies-for-anxious-dogs"
  },
  {
    "name": "dog anxiety during thunderstorms treatment",
    "slug": "dog-anxiety-during-thunderstorms-treatment"
  },
  {
    "name": "calming techniques for nervous dogs",
    "slug": "calming-techniques-for-nervous-dogs"
  },
  {
    "name": "anxiety-reducing toys for dogs",
    "slug": "anxiety-reducing-toys-for-dogs"
  },
  {
    "name": "anxiety support for older dogs",
    "slug": "anxiety-support-for-older-dogs"
  },
  {
    "name": "stress management solutions for dogs",
    "slug": "stress-management-solutions-for-dogs"
  },
  {
    "name": "soothing collars for stressed dogs",
    "slug": "soothing-collars-for-stressed-dogs"
  },
  {
    "name": "dog anxiety treatments at home",
    "slug": "dog-anxiety-treatments-at-home"
  },
  {
    "name": "natural calming options for dogs",
    "slug": "natural-calming-options-for-dogs"
  },
  {
    "name": "helping dogs with separation anxiety",
    "slug": "helping-dogs-with-separation-anxiety"
  },
  {
    "name": "calming routines for nervous dogs",
    "slug": "calming-routines-for-nervous-dogs"
  },
  {
    "name": "natural dog anxiety relief products",
    "slug": "natural-dog-anxiety-relief-products"
  },
  {
    "name": "pet anxiety support for dogs",
    "slug": "pet-anxiety-support-for-dogs"
  },
  {
    "name": "managing anxiety in senior dogs",
    "slug": "managing-anxiety-in-senior-dogs"
  },
  {
    "name": "best calming products for dogs",
    "slug": "best-calming-products-for-dogs"
  },
  {
    "name": "holistic approaches to dog anxiety",
    "slug": "holistic-approaches-to-dog-anxiety"
  },
  {
    "name": "natural sprays for anxious dogs",
    "slug": "natural-sprays-for-anxious-dogs"
  },
  {
    "name": "remedies for storm anxiety dogs",
    "slug": "remedies-for-storm-anxiety-dogs"
  },
  {
    "name": "home treatments for dog anxiety",
    "slug": "home-treatments-for-dog-anxiety"
  },
  {
    "name": "anxiety-reducing treats for dogs",
    "slug": "anxiety-reducing-treats-for-dogs"
  },
  {
    "name": "managing dog anxiety naturally",
    "slug": "managing-dog-anxiety-naturally"
  },
  {
    "name": "dog-friendly anxiety relief chews",
    "slug": "dog-friendly-anxiety-relief-chews"
  },
  {
    "name": "calming solutions for pet dogs",
    "slug": "calming-solutions-for-pet-dogs"
  },
  {
    "name": "stress-relief tools for anxious dogs",
    "slug": "stress-relief-tools-for-anxious-dogs"
  },
  {
    "name": "holistic solutions for dog stress",
    "slug": "holistic-solutions-for-dog-stress"
  },
  {
    "name": "herbal supplements for dog anxiety",
    "slug": "herbal-supplements-for-dog-anxiety"
  },
  {
    "name": "anxiety collars for dogs with stress",
    "slug": "anxiety-collars-for-dogs-with-stress"
  },
  {
    "name": "natural stress relievers for dogs",
    "slug": "natural-stress-relievers-for-dogs"
  },
  {
    "name": "behavioral tips for stressed dogs",
    "slug": "behavioral-tips-for-stressed-dogs"
  },
  {
    "name": "soothing chews for dogs’ anxiety",
    "slug": "soothing-chews-for-dogs-anxiety"
  },
  {
    "name": "calming sprays for nervous dogs",
    "slug": "calming-sprays-for-nervous-dogs"
  },
  {
    "name": "best anxiety solutions for dogs",
    "slug": "best-anxiety-solutions-for-dogs"
  },
  {
    "name": "relaxation techniques for stressed dogs",
    "slug": "relaxation-techniques-for-stressed-dogs"
  },
  {
    "name": "dog anxiety during travel solutions",
    "slug": "dog-anxiety-during-travel-solutions"
  },
  {
    "name": "calming oils for dogs with anxiety",
    "slug": "calming-oils-for-dogs-with-anxiety"
  },
  {
    "name": "dog-friendly anxiety sprays",
    "slug": "dog-friendly-anxiety-sprays"
  },
  {
    "name": "calming dog beds for anxious pets",
    "slug": "calming-dog-beds-for-anxious-pets"
  },
  {
    "name": "natural calming aids for dogs",
    "slug": "natural-calming-aids-for-dogs"
  },
  {
    "name": "dog anxiety home treatment solutions",
    "slug": "dog-anxiety-home-treatment-solutions"
  },
  {
    "name": "relaxing collars for nervous dogs",
    "slug": "relaxing-collars-for-nervous-dogs"
  },
  {
    "name": "natural stress relief products dogs",
    "slug": "natural-stress-relief-products-dogs"
  },
  {
    "name": "dog anxiety soothing techniques",
    "slug": "dog-anxiety-soothing-techniques"
  },
  {
    "name": "calming routines for pet dogs",
    "slug": "calming-routines-for-pet-dogs"
  },
  {
    "name": "supplements for dog travel anxiety",
    "slug": "supplements-for-dog-travel-anxiety"
  },
  {
    "name": "natural dog calming toys",
    "slug": "natural-dog-calming-toys"
  },
  {
    "name": "herbal stress solutions for dogs",
    "slug": "herbal-stress-solutions-for-dogs"
  },
  {
    "name": "anxiety-friendly activities for dogs",
    "slug": "anxiety-friendly-activities-for-dogs"
  },
  {
    "name": "calming diffusers for anxious dogs",
    "slug": "calming-diffusers-for-anxious-dogs"
  },
  {
    "name": "natural treatments for dog anxiety symptoms",
    "slug": "natural-treatments-for-dog-anxiety-symptoms"
  },
  {
    "name": "best natural anxiety relief for dogs",
    "slug": "best-natural-anxiety-relief-for-dogs"
  },
  {
    "name": "holistic approaches to dog stress",
    "slug": "holistic-approaches-to-dog-stress"
  },
  {
    "name": "soothing solutions for anxious dogs",
    "slug": "soothing-solutions-for-anxious-dogs"
  },
  {
    "name": "relaxation products for dog anxiety",
    "slug": "relaxation-products-for-dog-anxiety"
  },
  {
    "name": "stress management tips for dogs",
    "slug": "stress-management-tips-for-dogs"
  },
  {
    "name": "natural calming oils for dogs",
    "slug": "natural-calming-oils-for-dogs"
  },
  {
    "name": "anxiety relief routines for dogs",
    "slug": "anxiety-relief-routines-for-dogs"
  },
  {
    "name": "dog stress relief home remedies",
    "slug": "dog-stress-relief-home-remedies"
  },
  {
    "name": "dog-friendly calming routines",
    "slug": "dog-friendly-calming-routines"
  },
  {
    "name": "relaxing activities for anxious dogs",
    "slug": "relaxing-activities-for-anxious-dogs"
  },
  {
    "name": "natural solutions for stressed dogs",
    "slug": "natural-solutions-for-stressed-dogs"
  },
  {
    "name": "calming practices for nervous dogs",
    "slug": "calming-practices-for-nervous-dogs"
  },
  {
    "name": "home remedies for dog anxiety symptoms",
    "slug": "home-remedies-for-dog-anxiety-symptoms"
  },
  {
    "name": "pet-friendly stress relief for dogs",
    "slug": "pet-friendly-stress-relief-for-dogs"
  },
  {
    "name": "relaxing toys for dogs’ anxiety",
    "slug": "relaxing-toys-for-dogs-anxiety"
  },
  {
    "name": "natural sprays for dog anxiety",
    "slug": "natural-sprays-for-dog-anxiety"
  },
  {
    "name": "anxiety relief techniques for dogs",
    "slug": "anxiety-relief-techniques-for-dogs"
  },
  {
    "name": "calming toys for anxious dogs",
    "slug": "calming-toys-for-anxious-dogs"
  },
  {
    "name": "dog stress-relief routines",
    "slug": "dog-stress-relief-routines"
  },
  {
    "name": "dog-friendly natural sedatives",
    "slug": "dog-friendly-natural-sedatives"
  },
  {
    "name": "managing stress in older dogs",
    "slug": "managing-stress-in-older-dogs"
  },
  {
    "name": "calming pet anxiety remedies dogs",
    "slug": "calming-pet-anxiety-remedies-dogs"
  },
  {
    "name": "holistic stress management for dogs",
    "slug": "holistic-stress-management-for-dogs"
  },
  {
    "name": "dog-friendly anxiety vests",
    "slug": "dog-friendly-anxiety-vests"
  },
  {
    "name": "dog anxiety prevention techniques",
    "slug": "dog-anxiety-prevention-techniques"
  },
  {
    "name": "stress-free dog environment solutions",
    "slug": "stress-free-dog-environment-solutions"
  },
  {
    "name": "best routines for dog anxiety",
    "slug": "best-routines-for-dog-anxiety"
  },
  {
    "name": "calming chews for stressed dogs",
    "slug": "calming-chews-for-stressed-dogs"
  },
  {
    "name": "natural relaxation solutions for dogs",
    "slug": "natural-relaxation-solutions-for-dogs"
  },
  {
    "name": "managing travel anxiety in dogs",
    "slug": "managing-travel-anxiety-in-dogs"
  },
  {
    "name": "herbal treatments for dog stress",
    "slug": "herbal-treatments-for-dog-stress"
  },
  {
    "name": "natural supplements for anxious dogs",
    "slug": "natural-supplements-for-anxious-dogs"
  },
  {
    "name": "stress-reduction solutions for dogs",
    "slug": "stress-reduction-solutions-for-dogs"
  },
  {
    "name": "best anxiety treatments for dogs",
    "slug": "best-anxiety-treatments-for-dogs"
  },
  {
    "name": "dog-friendly relaxation routines",
    "slug": "dog-friendly-relaxation-routines"
  },
  {
    "name": "soothing collars for anxious dogs",
    "slug": "soothing-collars-for-anxious-dogs"
  },
  {
    "name": "calming routines for stressed dogs",
    "slug": "calming-routines-for-stressed-dogs"
  },
  {
    "name": "dog-friendly stress management techniques",
    "slug": "dog-friendly-stress-management-techniques"
  },
  {
    "name": "pet-safe stress relievers for dogs",
    "slug": "pet-safe-stress-relievers-for-dogs"
  },
  {
    "name": "holistic anxiety solutions for dogs",
    "slug": "holistic-anxiety-solutions-for-dogs"
  },
  {
    "name": "dog-friendly anti-stress sprays",
    "slug": "dog-friendly-anti-stress-sprays"
  },
  {
    "name": "natural remedies for dog stress",
    "slug": "natural-remedies-for-dog-stress"
  },
  {
    "name": "herbal stress relievers for dogs",
    "slug": "herbal-stress-relievers-for-dogs"
  },
  {
    "name": "calming techniques for anxious dogs",
    "slug": "calming-techniques-for-anxious-dogs"
  },
  {
    "name": "cbd for dogs pain",
    "slug": "cbd-for-dogs-pain"
  },
  {
    "name": "cbd for dog joints",
    "slug": "cbd-for-dog-joints"
  },
  {
    "name": "cbd for dog arthritis",
    "slug": "cbd-for-dog-arthritis"
  },
  {
    "name": "cbd for dogs with hip problems",
    "slug": "cbd-for-dogs-with-hip-problems"
  },
  {
    "name": "dog cbd for pain",
    "slug": "dog-cbd-for-pain"
  },
  {
    "name": "dog joint supplements",
    "slug": "dog-joint-supplements"
  },
  {
    "name": "managing dog arthritis",
    "slug": "managing-dog-arthritis"
  },
  {
    "name": "arthritis support dogs",
    "slug": "arthritis-support-dogs"
  },
  {
    "name": "canine joint health",
    "slug": "canine-joint-health"
  },
  {
    "name": "hip support dogs",
    "slug": "hip-support-dogs"
  },
  {
    "name": "dog pain management",
    "slug": "dog-pain-management"
  },
  {
    "name": "dog arthritis treatments",
    "slug": "dog-arthritis-treatments"
  },
  {
    "name": "dog arthritis support",
    "slug": "dog-arthritis-support"
  },
  {
    "name": "senior dog mobility",
    "slug": "senior-dog-mobility"
  },
  {
    "name": "dog joint exercises",
    "slug": "dog-joint-exercises"
  },
  {
    "name": "canine arthritis management",
    "slug": "canine-arthritis-management"
  },
  {
    "name": "dog arthritis therapies",
    "slug": "dog-arthritis-therapies"
  },
  {
    "name": "dog arthritis diets",
    "slug": "dog-arthritis-diets"
  },
  {
    "name": "dog pain relief",
    "slug": "dog-pain-relief"
  },
  {
    "name": "canine hip arthritis",
    "slug": "canine-hip-arthritis"
  },
  {
    "name": "dog hip pain",
    "slug": "dog-hip-pain"
  },
  {
    "name": "arthritis supplements dogs",
    "slug": "arthritis-supplements-dogs"
  },
  {
    "name": "dog mobility support",
    "slug": "dog-mobility-support"
  },
  {
    "name": "pain-free dog solutions",
    "slug": "pain-free-dog-solutions"
  },
  {
    "name": "mobility aids dogs",
    "slug": "mobility-aids-dogs"
  },
  {
    "name": "dog-friendly arthritis care",
    "slug": "dog-friendly-arthritis-care"
  },
  {
    "name": "senior dog exercises",
    "slug": "senior-dog-exercises"
  },
  {
    "name": "dog-friendly joint support",
    "slug": "dog-friendly-joint-support"
  },
  {
    "name": "dog arthritis solutions",
    "slug": "dog-arthritis-solutions"
  },
  {
    "name": "dog-friendly pain remedies",
    "slug": "dog-friendly-pain-remedies"
  },
  {
    "name": "canine joint supplements",
    "slug": "canine-joint-supplements"
  },
  {
    "name": "pain-relief solutions dogs",
    "slug": "pain-relief-solutions-dogs"
  },
  {
    "name": "dog-friendly joint care",
    "slug": "dog-friendly-joint-care"
  },
  {
    "name": "canine mobility support",
    "slug": "canine-mobility-support"
  },
  {
    "name": "senior dog pain",
    "slug": "senior-dog-pain"
  },
  {
    "name": "arthritis management options",
    "slug": "arthritis-management-options"
  },
  {
    "name": "dog-friendly anti-inflammatories",
    "slug": "dog-friendly-anti-inflammatories"
  },
  {
    "name": "natural pain relief for dogs",
    "slug": "natural-pain-relief-for-dogs"
  },
  {
    "name": "best supplements for dog arthritis",
    "slug": "best-supplements-for-dog-arthritis"
  },
  {
    "name": "joint health support for dogs",
    "slug": "joint-health-support-for-dogs"
  },
  {
    "name": "herbal remedies for dog arthritis",
    "slug": "herbal-remedies-for-dog-arthritis"
  },
  {
    "name": "managing hip pain in dogs",
    "slug": "managing-hip-pain-in-dogs"
  },
  {
    "name": "natural remedies for dog joints",
    "slug": "natural-remedies-for-dog-joints"
  },
  {
    "name": "supplements for canine joint health",
    "slug": "supplements-for-canine-joint-health"
  },
  {
    "name": "best joint care for dogs",
    "slug": "best-joint-care-for-dogs"
  },
  {
    "name": "natural treatments for arthritis dogs",
    "slug": "natural-treatments-for-arthritis-dogs"
  },
  {
    "name": "hip and joint care for dogs",
    "slug": "hip-and-joint-care-for-dogs"
  },
  {
    "name": "pain management for senior dogs",
    "slug": "pain-management-for-senior-dogs"
  },
  {
    "name": "natural dog joint health supplements",
    "slug": "natural-dog-joint-health-supplements"
  },
  {
    "name": "arthritis-friendly activities for dogs",
    "slug": "arthritis-friendly-activities-for-dogs"
  },
  {
    "name": "home remedies for arthritic dogs",
    "slug": "home-remedies-for-arthritic-dogs"
  },
  {
    "name": "natural remedies for dog pain",
    "slug": "natural-remedies-for-dog-pain"
  },
  {
    "name": "best mobility supplements for dogs",
    "slug": "best-mobility-supplements-for-dogs"
  },
  {
    "name": "joint health diets for dogs",
    "slug": "joint-health-diets-for-dogs"
  },
  {
    "name": "natural treatments for dog hips",
    "slug": "natural-treatments-for-dog-hips"
  },
  {
    "name": "holistic arthritis care for dogs",
    "slug": "holistic-arthritis-care-for-dogs"
  },
  {
    "name": "mobility aids for aging dogs",
    "slug": "mobility-aids-for-aging-dogs"
  },
  {
    "name": "best pain solutions for dogs",
    "slug": "best-pain-solutions-for-dogs"
  },
  {
    "name": "natural anti-inflammatory for dogs",
    "slug": "natural-anti-inflammatory-for-dogs"
  },
  {
    "name": "hip pain relief for dogs",
    "slug": "hip-pain-relief-for-dogs"
  },
  {
    "name": "arthritis pain solutions for dogs",
    "slug": "arthritis-pain-solutions-for-dogs"
  },
  {
    "name": "joint supplements for older dogs",
    "slug": "joint-supplements-for-older-dogs"
  },
  {
    "name": "best arthritis treatments for dogs",
    "slug": "best-arthritis-treatments-for-dogs"
  },
  {
    "name": "natural therapies for arthritic dogs",
    "slug": "natural-therapies-for-arthritic-dogs"
  },
  {
    "name": "supplements for dog hip pain",
    "slug": "supplements-for-dog-hip-pain"
  },
  {
    "name": "managing canine arthritis naturally",
    "slug": "managing-canine-arthritis-naturally"
  },
  {
    "name": "herbal anti-inflammatory for dogs",
    "slug": "herbal-anti-inflammatory-for-dogs"
  },
  {
    "name": "natural supplements for dog joints",
    "slug": "natural-supplements-for-dog-joints"
  },
  {
    "name": "hip and joint pain relief dogs",
    "slug": "hip-and-joint-pain-relief-dogs"
  },
  {
    "name": "holistic joint care for dogs",
    "slug": "holistic-joint-care-for-dogs"
  },
  {
    "name": "senior dog joint pain support",
    "slug": "senior-dog-joint-pain-support"
  },
  {
    "name": "arthritis-friendly diets for dogs",
    "slug": "arthritis-friendly-diets-for-dogs"
  },
  {
    "name": "best natural remedies for dog arthritis",
    "slug": "best-natural-remedies-for-dog-arthritis"
  },
  {
    "name": "joint and mobility support dogs",
    "slug": "joint-and-mobility-support-dogs"
  },
  {
    "name": "managing arthritis in aging dogs",
    "slug": "managing-arthritis-in-aging-dogs"
  },
  {
    "name": "natural pain solutions for dogs",
    "slug": "natural-pain-solutions-for-dogs"
  },
  {
    "name": "joint care for active dogs",
    "slug": "joint-care-for-active-dogs"
  },
  {
    "name": "home remedies for dog joints",
    "slug": "home-remedies-for-dog-joints"
  },
  {
    "name": "pain management tips for dogs",
    "slug": "pain-management-tips-for-dogs"
  },
  {
    "name": "herbal supplements for dog arthritis",
    "slug": "herbal-supplements-for-dog-arthritis"
  },
  {
    "name": "natural dog arthritis treatment options",
    "slug": "natural-dog-arthritis-treatment-options"
  },
  {
    "name": "arthritis pain relief home remedies",
    "slug": "arthritis-pain-relief-home-remedies"
  },
  {
    "name": "joint support for active dogs",
    "slug": "joint-support-for-active-dogs"
  },
  {
    "name": "natural inflammation relief for dogs",
    "slug": "natural-inflammation-relief-for-dogs"
  },
  {
    "name": "joint supplements for working dogs",
    "slug": "joint-supplements-for-working-dogs"
  },
  {
    "name": "holistic pain relief for dogs",
    "slug": "holistic-pain-relief-for-dogs"
  },
  {
    "name": "natural joint care for senior dogs",
    "slug": "natural-joint-care-for-senior-dogs"
  },
  {
    "name": "dog arthritis home treatment solutions",
    "slug": "dog-arthritis-home-treatment-solutions"
  },
  {
    "name": "mobility support aids for dogs",
    "slug": "mobility-support-aids-for-dogs"
  },
  {
    "name": "natural hip support for dogs",
    "slug": "natural-hip-support-for-dogs"
  },
  {
    "name": "canine arthritis joint care solutions",
    "slug": "canine-arthritis-joint-care-solutions"
  },
  {
    "name": "joint pain management for dogs",
    "slug": "joint-pain-management-for-dogs"
  },
  {
    "name": "natural anti-inflammatory support dogs",
    "slug": "natural-anti-inflammatory-support-dogs"
  },
  {
    "name": "best diets for dog arthritis",
    "slug": "best-diets-for-dog-arthritis"
  },
  {
    "name": "pain-free activities for dogs",
    "slug": "pain-free-activities-for-dogs"
  },
  {
    "name": "hip health for senior dogs",
    "slug": "hip-health-for-senior-dogs"
  },
  {
    "name": "natural joint relief for dogs",
    "slug": "natural-joint-relief-for-dogs"
  },
  {
    "name": "joint pain home remedies dogs",
    "slug": "joint-pain-home-remedies-dogs"
  },
  {
    "name": "supplements for hip pain dogs",
    "slug": "supplements-for-hip-pain-dogs"
  },
  {
    "name": "arthritis pain management for dogs",
    "slug": "arthritis-pain-management-for-dogs"
  },
  {
    "name": "natural pain remedies for arthritic dogs",
    "slug": "natural-pain-remedies-for-arthritic-dogs"
  },
  {
    "name": "anti-inflammatory supplements for dogs",
    "slug": "anti-inflammatory-supplements-for-dogs"
  },
  {
    "name": "best supplements for dog hip pain",
    "slug": "best-supplements-for-dog-hip-pain"
  },
  {
    "name": "pain management therapies for dogs",
    "slug": "pain-management-therapies-for-dogs"
  },
  {
    "name": "arthritis pain relief tips for dogs",
    "slug": "arthritis-pain-relief-tips-for-dogs"
  },
  {
    "name": "joint support food for dogs",
    "slug": "joint-support-food-for-dogs"
  },
  {
    "name": "natural arthritis treatment for dogs",
    "slug": "natural-arthritis-treatment-for-dogs"
  },
  {
    "name": "pain-free mobility for senior dogs",
    "slug": "pain-free-mobility-for-senior-dogs"
  },
  {
    "name": "holistic dog joint health care",
    "slug": "holistic-dog-joint-health-care"
  },
  {
    "name": "arthritis pain support for dogs",
    "slug": "arthritis-pain-support-for-dogs"
  },
  {
    "name": "supplements for joint health dogs",
    "slug": "supplements-for-joint-health-dogs"
  },
  {
    "name": "best joint remedies for dogs",
    "slug": "best-joint-remedies-for-dogs"
  },
  {
    "name": "managing dog arthritis pain naturally",
    "slug": "managing-dog-arthritis-pain-naturally"
  },
  {
    "name": "arthritis-friendly joint health supplements",
    "slug": "arthritis-friendly-joint-health-supplements"
  },
  {
    "name": "dog hip pain management naturally",
    "slug": "dog-hip-pain-management-naturally"
  },
  {
    "name": "holistic arthritis care tips dogs",
    "slug": "holistic-arthritis-care-tips-dogs"
  },
  {
    "name": "natural joint pain relief solutions",
    "slug": "natural-joint-pain-relief-solutions"
  },
  {
    "name": "home care for dog arthritis pain",
    "slug": "home-care-for-dog-arthritis-pain"
  },
  {
    "name": "canine arthritis management strategies",
    "slug": "canine-arthritis-management-strategies"
  },
  {
    "name": "hip pain exercises for dogs",
    "slug": "hip-pain-exercises-for-dogs"
  },
  {
    "name": "supplements for senior dog joints",
    "slug": "supplements-for-senior-dog-joints"
  },
  {
    "name": "managing hip arthritis pain dogs",
    "slug": "managing-hip-arthritis-pain-dogs"
  },
  {
    "name": "holistic care for arthritic dogs",
    "slug": "holistic-care-for-arthritic-dogs"
  },
  {
    "name": "joint pain care solutions dogs",
    "slug": "joint-pain-care-solutions-dogs"
  },
  {
    "name": "natural anti-inflammatory remedies dogs",
    "slug": "natural-anti-inflammatory-remedies-dogs"
  },
  {
    "name": "dog hip health support supplements",
    "slug": "dog-hip-health-support-supplements"
  },
  {
    "name": "pain relief tips for older dogs",
    "slug": "pain-relief-tips-for-older-dogs"
  },
  {
    "name": "dog skin infection",
    "slug": "dog-skin-infection"
  },
  {
    "name": "dog skin irritation",
    "slug": "dog-skin-irritation"
  },
  {
    "name": "dog skin allergies",
    "slug": "dog-skin-allergies"
  },
  {
    "name": "dog skin redness",
    "slug": "dog-skin-redness"
  },
  {
    "name": "dog skin rashes",
    "slug": "dog-skin-rashes"
  },
  {
    "name": "dog skin yeast",
    "slug": "dog-skin-yeast"
  },
  {
    "name": "dog skin problems",
    "slug": "dog-skin-problems"
  },
  {
    "name": "dog skin healing",
    "slug": "dog-skin-healing"
  },
  {
    "name": "canine skin irritation",
    "slug": "canine-skin-irritation"
  },
  {
    "name": "dog skin care",
    "slug": "dog-skin-care"
  },
  {
    "name": "dog skin inflammation",
    "slug": "dog-skin-inflammation"
  },
  {
    "name": "dog skin treatment",
    "slug": "dog-skin-treatment"
  },
  {
    "name": "canine skin issues",
    "slug": "canine-skin-issues"
  },
  {
    "name": "dog skin remedies",
    "slug": "dog-skin-remedies"
  },
  {
    "name": "dog skin dryness",
    "slug": "dog-skin-dryness"
  },
  {
    "name": "dog skin scratching",
    "slug": "dog-skin-scratching"
  },
  {
    "name": "dog skin scabs",
    "slug": "dog-skin-scabs"
  },
  {
    "name": "dog skin fungus",
    "slug": "dog-skin-fungus"
  },
  {
    "name": "canine skin rash",
    "slug": "canine-skin-rash"
  },
  {
    "name": "dog skin sores",
    "slug": "dog-skin-sores"
  },
  {
    "name": "dog skin support",
    "slug": "dog-skin-support"
  },
  {
    "name": "canine skin infections",
    "slug": "canine-skin-infections"
  },
  {
    "name": "dog skin moisturizing",
    "slug": "dog-skin-moisturizing"
  },
  {
    "name": "dog skin relief",
    "slug": "dog-skin-relief"
  },
  {
    "name": "canine skin health",
    "slug": "canine-skin-health"
  },
  {
    "name": "dog skin infection remedies",
    "slug": "dog-skin-infection-remedies"
  },
  {
    "name": "dog skin irritation solutions",
    "slug": "dog-skin-irritation-solutions"
  },
  {
    "name": "dog skin yeast infection",
    "slug": "dog-skin-yeast-infection"
  },
  {
    "name": "dog skin issues treatment",
    "slug": "dog-skin-issues-treatment"
  },
  {
    "name": "dog skin rash care",
    "slug": "dog-skin-rash-care"
  },
  {
    "name": "dog skin allergy remedies",
    "slug": "dog-skin-allergy-remedies"
  },
  {
    "name": "dog skin infection causes",
    "slug": "dog-skin-infection-causes"
  },
  {
    "name": "dog skin irritation cream",
    "slug": "dog-skin-irritation-cream"
  },
  {
    "name": "dog skin treatment natural",
    "slug": "dog-skin-treatment-natural"
  },
  {
    "name": "dog skin health supplements",
    "slug": "dog-skin-health-supplements"
  },
  {
    "name": "dog skin irritation relief",
    "slug": "dog-skin-irritation-relief"
  },
  {
    "name": "dog skin healing remedies",
    "slug": "dog-skin-healing-remedies"
  },
  {
    "name": "dog skin rash shampoo",
    "slug": "dog-skin-rash-shampoo"
  },
  {
    "name": "dog skin yeast treatment",
    "slug": "dog-skin-yeast-treatment"
  },
  {
    "name": "dog skin fungal infection",
    "slug": "dog-skin-fungal-infection"
  },
  {
    "name": "dog skin allergy solutions",
    "slug": "dog-skin-allergy-solutions"
  },
  {
    "name": "dog skin infection signs",
    "slug": "dog-skin-infection-signs"
  },
  {
    "name": "dog skin irritation home care",
    "slug": "dog-skin-irritation-home-care"
  },
  {
    "name": "dog skin inflammation remedies",
    "slug": "dog-skin-inflammation-remedies"
  },
  {
    "name": "dog skin infection care",
    "slug": "dog-skin-infection-care"
  },
  {
    "name": "dog skin redness treatment",
    "slug": "dog-skin-redness-treatment"
  },
  {
    "name": "dog skin healing products",
    "slug": "dog-skin-healing-products"
  },
  {
    "name": "dog skin irritation relief spray",
    "slug": "dog-skin-irritation-relief-spray"
  },
  {
    "name": "dog skin bacterial infection",
    "slug": "dog-skin-bacterial-infection"
  },
  {
    "name": "dog skin infection home care",
    "slug": "dog-skin-infection-home-care"
  },
  {
    "name": "dog skin scabs treatment",
    "slug": "dog-skin-scabs-treatment"
  },
  {
    "name": "dog skin irritation natural care",
    "slug": "dog-skin-irritation-natural-care"
  },
  {
    "name": "dog skin infection natural remedies",
    "slug": "dog-skin-infection-natural-remedies"
  },
  {
    "name": "dog skin irritation healing creams",
    "slug": "dog-skin-irritation-healing-creams"
  },
  {
    "name": "dog skin problems holistic care",
    "slug": "dog-skin-problems-holistic-care"
  },
  {
    "name": "dog skin rash soothing creams",
    "slug": "dog-skin-rash-soothing-creams"
  },
  {
    "name": "dog skin yeast infection shampoo",
    "slug": "dog-skin-yeast-infection-shampoo"
  },
  {
    "name": "dog skin infections antibiotics",
    "slug": "dog-skin-infections-antibiotics"
  },
  {
    "name": "dog skin infections holistic care",
    "slug": "dog-skin-infections-holistic-care"
  },
  {
    "name": "dog skin inflammation soothing products",
    "slug": "dog-skin-inflammation-soothing-products"
  },
  {
    "name": "dog skin irritation sprays",
    "slug": "dog-skin-irritation-sprays"
  },
  {
    "name": "dog skin healing balms",
    "slug": "dog-skin-healing-balms"
  },
  {
    "name": "dog skin health improvement tips",
    "slug": "dog-skin-health-improvement-tips"
  },
  {
    "name": "dog skin problems treatment guide",
    "slug": "dog-skin-problems-treatment-guide"
  },
  {
    "name": "dog skin rashes herbal remedies",
    "slug": "dog-skin-rashes-herbal-remedies"
  },
  {
    "name": "dog skin irritation anti-itch solutions",
    "slug": "dog-skin-irritation-anti-itch-solutions"
  },
  {
    "name": "dog skin fungal remedies",
    "slug": "dog-skin-fungal-remedies"
  },
  {
    "name": "dog skin yeast holistic care",
    "slug": "dog-skin-yeast-holistic-care"
  },
  {
    "name": "dog skin health diet changes",
    "slug": "dog-skin-health-diet-changes"
  },
  {
    "name": "dog skin issues home remedies",
    "slug": "dog-skin-issues-home-remedies"
  },
  {
    "name": "dog skin rash solutions natural",
    "slug": "dog-skin-rash-solutions-natural"
  },
  {
    "name": "dog skin irritation herbal care",
    "slug": "dog-skin-irritation-herbal-care"
  },
  {
    "name": "dog skin inflammation herbal sprays",
    "slug": "dog-skin-inflammation-herbal-sprays"
  },
  {
    "name": "dog skin rash calming sprays",
    "slug": "dog-skin-rash-calming-sprays"
  },
  {
    "name": "dog skin irritation oatmeal baths",
    "slug": "dog-skin-irritation-oatmeal-baths"
  },
  {
    "name": "dog glaucoma treatment",
    "slug": "dog-glaucoma-treatment"
  },
  {
    "name": "dog glaucoma symptoms",
    "slug": "dog-glaucoma-symptoms"
  },
  {
    "name": "canine glaucoma care",
    "slug": "canine-glaucoma-care"
  },
  {
    "name": "dog glaucoma relief",
    "slug": "dog-glaucoma-relief"
  },
  {
    "name": "dog glaucoma pressure",
    "slug": "dog-glaucoma-pressure"
  },
  {
    "name": "dog glaucoma management",
    "slug": "dog-glaucoma-management"
  },
  {
    "name": "dog glaucoma prevention",
    "slug": "dog-glaucoma-prevention"
  },
  {
    "name": "canine glaucoma treatment",
    "slug": "canine-glaucoma-treatment"
  },
  {
    "name": "dog glaucoma medication",
    "slug": "dog-glaucoma-medication"
  },
  {
    "name": "canine glaucoma symptoms",
    "slug": "canine-glaucoma-symptoms"
  },
  {
    "name": "dog glaucoma remedies",
    "slug": "dog-glaucoma-remedies"
  },
  {
    "name": "dog glaucoma control",
    "slug": "dog-glaucoma-control"
  },
  {
    "name": "dog glaucoma surgery",
    "slug": "dog-glaucoma-surgery"
  },
  {
    "name": "canine glaucoma solutions",
    "slug": "canine-glaucoma-solutions"
  },
  {
    "name": "dog glaucoma vision",
    "slug": "dog-glaucoma-vision"
  },
  {
    "name": "dog glaucoma support",
    "slug": "dog-glaucoma-support"
  },
  {
    "name": "canine glaucoma care",
    "slug": "canine-glaucoma-care"
  },
  {
    "name": "dog glaucoma progression",
    "slug": "dog-glaucoma-progression"
  },
  {
    "name": "dog glaucoma tips",
    "slug": "dog-glaucoma-tips"
  },
  {
    "name": "dog glaucoma recovery",
    "slug": "dog-glaucoma-recovery"
  },
  {
    "name": "dog glaucoma treatment natural",
    "slug": "dog-glaucoma-treatment-natural"
  },
  {
    "name": "dog glaucoma eye care",
    "slug": "dog-glaucoma-eye-care"
  },
  {
    "name": "dog glaucoma relief remedies",
    "slug": "dog-glaucoma-relief-remedies"
  },
  {
    "name": "dog glaucoma medication options",
    "slug": "dog-glaucoma-medication-options"
  },
  {
    "name": "dog glaucoma pressure relief",
    "slug": "dog-glaucoma-pressure-relief"
  },
  {
    "name": "dog glaucoma home care",
    "slug": "dog-glaucoma-home-care"
  },
  {
    "name": "dog glaucoma eye drops",
    "slug": "dog-glaucoma-eye-drops"
  },
  {
    "name": "dog glaucoma management strategies",
    "slug": "dog-glaucoma-management-strategies"
  },
  {
    "name": "dog glaucoma vision support",
    "slug": "dog-glaucoma-vision-support"
  },
  {
    "name": "dog glaucoma natural care",
    "slug": "dog-glaucoma-natural-care"
  },
  {
    "name": "dog glaucoma surgical treatment",
    "slug": "dog-glaucoma-surgical-treatment"
  },
  {
    "name": "dog glaucoma herbal solutions",
    "slug": "dog-glaucoma-herbal-solutions"
  },
  {
    "name": "dog glaucoma holistic remedies",
    "slug": "dog-glaucoma-holistic-remedies"
  },
  {
    "name": "dog glaucoma diagnosis tips",
    "slug": "dog-glaucoma-diagnosis-tips"
  },
  {
    "name": "dog glaucoma progression signs",
    "slug": "dog-glaucoma-progression-signs"
  },
  {
    "name": "dog glaucoma treatment options",
    "slug": "dog-glaucoma-treatment-options"
  },
  {
    "name": "dog glaucoma pressure management",
    "slug": "dog-glaucoma-pressure-management"
  },
  {
    "name": "dog glaucoma relief eye care",
    "slug": "dog-glaucoma-relief-eye-care"
  },
  {
    "name": "dog glaucoma diet changes",
    "slug": "dog-glaucoma-diet-changes"
  },
  {
    "name": "dog glaucoma pain relief",
    "slug": "dog-glaucoma-pain-relief"
  },
  {
    "name": "dog glaucoma early signs",
    "slug": "dog-glaucoma-early-signs"
  },
  {
    "name": "dog glaucoma eye protection",
    "slug": "dog-glaucoma-eye-protection"
  },
  {
    "name": "dog glaucoma medications side effects",
    "slug": "dog-glaucoma-medications-side-effects"
  },
  {
    "name": "dog glaucoma supportive care",
    "slug": "dog-glaucoma-supportive-care"
  },
  {
    "name": "dog glaucoma preventative measures",
    "slug": "dog-glaucoma-preventative-measures"
  },
  {
    "name": "dog glaucoma eye health support",
    "slug": "dog-glaucoma-eye-health-support"
  },
  {
    "name": "dog glaucoma inflammation control",
    "slug": "dog-glaucoma-inflammation-control"
  },
  {
    "name": "dog glaucoma natural healing",
    "slug": "dog-glaucoma-natural-healing"
  },
  {
    "name": "dog glaucoma vision preservation",
    "slug": "dog-glaucoma-vision-preservation"
  },
  {
    "name": "dog glaucoma stress management",
    "slug": "dog-glaucoma-stress-management"
  },
  {
    "name": "dog glaucoma herbal eye drops",
    "slug": "dog-glaucoma-herbal-eye-drops"
  },
  {
    "name": "dog glaucoma eye irritation relief",
    "slug": "dog-glaucoma-eye-irritation-relief"
  },
  {
    "name": "dog glaucoma management plan",
    "slug": "dog-glaucoma-management-plan"
  },
  {
    "name": "dog glaucoma supportive therapies",
    "slug": "dog-glaucoma-supportive-therapies"
  },
  {
    "name": "dog glaucoma relief tips",
    "slug": "dog-glaucoma-relief-tips"
  },
  {
    "name": "dog glaucoma anti-inflammatory options",
    "slug": "dog-glaucoma-anti-inflammatory-options"
  },
  {
    "name": "dog glaucoma diagnosis tools",
    "slug": "dog-glaucoma-diagnosis-tools"
  },
  {
    "name": "dog glaucoma blindness prevention",
    "slug": "dog-glaucoma-blindness-prevention"
  },
  {
    "name": "dog glaucoma veterinary solutions",
    "slug": "dog-glaucoma-veterinary-solutions"
  },
  {
    "name": "dog glaucoma comprehensive care",
    "slug": "dog-glaucoma-comprehensive-care"
  },
  {
    "name": "dog glaucoma at-home management",
    "slug": "dog-glaucoma-at-home-management"
  },
  {
    "name": "dog glaucoma soothing eye washes",
    "slug": "dog-glaucoma-soothing-eye-washes"
  },
  {
    "name": "dog glaucoma holistic treatment plan",
    "slug": "dog-glaucoma-holistic-treatment-plan"
  },
  {
    "name": "dog glaucoma eye pressure reduction",
    "slug": "dog-glaucoma-eye-pressure-reduction"
  },
  {
    "name": "dog glaucoma vision maintenance",
    "slug": "dog-glaucoma-vision-maintenance"
  },
  {
    "name": "dog glaucoma daily eye care tips",
    "slug": "dog-glaucoma-daily-eye-care-tips"
  },
  {
    "name": "dog glaucoma pain management plan",
    "slug": "dog-glaucoma-pain-management-plan"
  },
  {
    "name": "dog glaucoma symptom control",
    "slug": "dog-glaucoma-symptom-control"
  },
  {
    "name": "dog glaucoma regular checkups",
    "slug": "dog-glaucoma-regular-checkups"
  },
  {
    "name": "dog yeast infection",
    "slug": "dog-yeast-infection"
  },
  {
    "name": "dog yeast symptoms",
    "slug": "dog-yeast-symptoms"
  },
  {
    "name": "canine yeast infections",
    "slug": "canine-yeast-infections"
  },
  {
    "name": "dog yeast treatment",
    "slug": "dog-yeast-treatment"
  },
  {
    "name": "dog yeast remedies",
    "slug": "dog-yeast-remedies"
  },
  {
    "name": "dog yeast shampoo",
    "slug": "dog-yeast-shampoo"
  },
  {
    "name": "canine yeast treatment",
    "slug": "canine-yeast-treatment"
  },
  {
    "name": "dog yeast solution",
    "slug": "dog-yeast-solution"
  },
  {
    "name": "dog yeast care",
    "slug": "dog-yeast-care"
  },
  {
    "name": "dog yeast prevention",
    "slug": "dog-yeast-prevention"
  },
  {
    "name": "dog yeast control",
    "slug": "dog-yeast-control"
  },
  {
    "name": "dog yeast itchiness",
    "slug": "dog-yeast-itchiness"
  },
  {
    "name": "dog yeast odor",
    "slug": "dog-yeast-odor"
  },
  {
    "name": "canine yeast management",
    "slug": "canine-yeast-management"
  },
  {
    "name": "dog yeast antibiotics",
    "slug": "dog-yeast-antibiotics"
  },
  {
    "name": "dog yeast diet",
    "slug": "dog-yeast-diet"
  },
  {
    "name": "dog yeast supplements",
    "slug": "dog-yeast-supplements"
  },
  {
    "name": "dog yeast remedies",
    "slug": "dog-yeast-remedies"
  },
  {
    "name": "dog yeast healing",
    "slug": "dog-yeast-healing"
  },
  {
    "name": "canine yeast solutions",
    "slug": "canine-yeast-solutions"
  },
  {
    "name": "dog yeast infection remedies",
    "slug": "dog-yeast-infection-remedies"
  },
  {
    "name": "dog yeast infection causes",
    "slug": "dog-yeast-infection-causes"
  },
  {
    "name": "dog yeast infection natural care",
    "slug": "dog-yeast-infection-natural-care"
  },
  {
    "name": "dog yeast infection symptoms",
    "slug": "dog-yeast-infection-symptoms"
  },
  {
    "name": "dog yeast infection treatment options",
    "slug": "dog-yeast-infection-treatment-options"
  },
  {
    "name": "dog yeast infection shampoo",
    "slug": "dog-yeast-infection-shampoo"
  },
  {
    "name": "dog yeast infection healing support",
    "slug": "dog-yeast-infection-healing-support"
  },
  {
    "name": "dog yeast infection diet changes",
    "slug": "dog-yeast-infection-diet-changes"
  },
  {
    "name": "dog yeast infection ear solutions",
    "slug": "dog-yeast-infection-ear-solutions"
  },
  {
    "name": "dog yeast infection paws remedies",
    "slug": "dog-yeast-infection-paws-remedies"
  },
  {
    "name": "dog yeast infection home treatment",
    "slug": "dog-yeast-infection-home-treatment"
  },
  {
    "name": "dog yeast infection anti-fungal care",
    "slug": "dog-yeast-infection-anti-fungal-care"
  },
  {
    "name": "dog yeast infection probiotics",
    "slug": "dog-yeast-infection-probiotics"
  },
  {
    "name": "dog yeast infection vinegar rinses",
    "slug": "dog-yeast-infection-vinegar-rinses"
  },
  {
    "name": "dog yeast infection natural supplements",
    "slug": "dog-yeast-infection-natural-supplements"
  },
  {
    "name": "dog yeast infection healing creams",
    "slug": "dog-yeast-infection-healing-creams"
  },
  {
    "name": "dog yeast infection skin solutions",
    "slug": "dog-yeast-infection-skin-solutions"
  },
  {
    "name": "dog yeast infection holistic treatment",
    "slug": "dog-yeast-infection-holistic-treatment"
  },
  {
    "name": "dog yeast infection antibiotics",
    "slug": "dog-yeast-infection-antibiotics"
  },
  {
    "name": "dog yeast infection diet support",
    "slug": "dog-yeast-infection-diet-support"
  },
  {
    "name": "dog yeast infection coconut oil care",
    "slug": "dog-yeast-infection-coconut-oil-care"
  },
  {
    "name": "dog yeast infection apple cider vinegar",
    "slug": "dog-yeast-infection-apple-cider-vinegar"
  },
  {
    "name": "dog yeast infection itching remedies",
    "slug": "dog-yeast-infection-itching-remedies"
  },
  {
    "name": "dog yeast infection natural sprays",
    "slug": "dog-yeast-infection-natural-sprays"
  },
  {
    "name": "dog yeast infection essential oils",
    "slug": "dog-yeast-infection-essential-oils"
  },
  {
    "name": "dog yeast infection herbal creams",
    "slug": "dog-yeast-infection-herbal-creams"
  },
  {
    "name": "dog yeast infection soothing solutions",
    "slug": "dog-yeast-infection-soothing-solutions"
  },
  {
    "name": "dog yeast infection natural healing",
    "slug": "dog-yeast-infection-natural-healing"
  },
  {
    "name": "dog yeast infection skin irritations",
    "slug": "dog-yeast-infection-skin-irritations"
  },
  {
    "name": "dog yeast infection ear cleaning solutions",
    "slug": "dog-yeast-infection-ear-cleaning-solutions"
  },
  {
    "name": "dog yeast infection anti-itch sprays",
    "slug": "dog-yeast-infection-anti-itch-sprays"
  },
  {
    "name": "dog yeast infection natural shampoos",
    "slug": "dog-yeast-infection-natural-shampoos"
  },
  {
    "name": "dog yeast infection skin redness relief",
    "slug": "dog-yeast-infection-skin-redness-relief"
  },
  {
    "name": "dog yeast infection inflammation solutions",
    "slug": "dog-yeast-infection-inflammation-solutions"
  },
  {
    "name": "dog yeast infection care tips",
    "slug": "dog-yeast-infection-care-tips"
  },
  {
    "name": "dog yeast infection dietary management",
    "slug": "dog-yeast-infection-dietary-management"
  },
  {
    "name": "dog yeast infection paw soaks",
    "slug": "dog-yeast-infection-paw-soaks"
  },
  {
    "name": "dog yeast infection home solutions",
    "slug": "dog-yeast-infection-home-solutions"
  },
  {
    "name": "dog yeast infection treatment plan",
    "slug": "dog-yeast-infection-treatment-plan"
  },
  {
    "name": "dog yeast infection alternative therapies",
    "slug": "dog-yeast-infection-alternative-therapies"
  },
  {
    "name": "dog yeast infection ongoing care",
    "slug": "dog-yeast-infection-ongoing-care"
  },
  {
    "name": "dog yeast infection healing regimens",
    "slug": "dog-yeast-infection-healing-regimens"
  },
  {
    "name": "dog yeast infection anti-itch products",
    "slug": "dog-yeast-infection-anti-itch-products"
  },
  {
    "name": "dog yeast infection dietary changes",
    "slug": "dog-yeast-infection-dietary-changes"
  },
  {
    "name": "dog yeast infection herbal care",
    "slug": "dog-yeast-infection-herbal-care"
  },
  {
    "name": "dog yeast infection daily maintenance",
    "slug": "dog-yeast-infection-daily-maintenance"
  },
  {
    "name": "dog yeast infection moisture control",
    "slug": "dog-yeast-infection-moisture-control"
  },
  {
    "name": "dog yeast infection fungal treatments",
    "slug": "dog-yeast-infection-fungal-treatments"
  },
  {
    "name": "dog yeast infection symptom relief",
    "slug": "dog-yeast-infection-symptom-relief"
  },
  {
    "name": "dog yeast infection support plan",
    "slug": "dog-yeast-infection-support-plan"
  },
  {
    "name": "homemade bone broth for dogs",
    "slug": "homemade-bone-broth-for-dogs"
  },
  {
    "name": "bone broth recipes for dogs",
    "slug": "bone-broth-recipes-for-dogs"
  },
  {
    "name": "bone broth benefits dogs",
    "slug": "bone-broth-benefits-dogs"
  },
  {
    "name": "bone broth for dogs with arthritis",
    "slug": "bone-broth-for-dogs-with-arthritis"
  },
  {
    "name": "bone broth for dogs joints",
    "slug": "bone-broth-for-dogs-joints"
  },
  {
    "name": "bone broth for dogs digestion",
    "slug": "bone-broth-for-dogs-digestion"
  },
  {
    "name": "bone broth for dogs immune system",
    "slug": "bone-broth-for-dogs-immune-system"
  },
  {
    "name": "bone broth for dogs skin",
    "slug": "bone-broth-for-dogs-skin"
  },
  {
    "name": "bone broth for dogs allergies",
    "slug": "bone-broth-for-dogs-allergies"
  },
  {
    "name": "bone broth for dogs with kidney disease",
    "slug": "bone-broth-for-dogs-with-kidney-disease"
  },
  {
    "name": "bone broth for dogs with cancer",
    "slug": "bone-broth-for-dogs-with-cancer"
  },
  {
    "name": "bone broth for dogs with pancreatitis",
    "slug": "bone-broth-for-dogs-with-pancreatitis"
  },
  {
    "name": "bone broth for dogs with sensitive stomachs",
    "slug": "bone-broth-for-dogs-with-sensitive-stomachs"
  },
  {
    "name": "bone broth for dogs with diarrhea",
    "slug": "bone-broth-for-dogs-with-diarrhea"
  },
  {
    "name": "bone broth for dogs with liver disease",
    "slug": "bone-broth-for-dogs-with-liver-disease"
  },
  {
    "name": "bone broth for dogs with heart disease",
    "slug": "bone-broth-for-dogs-with-heart-disease"
  },
  {
    "name": "bone broth for dogs with dental issues",
    "slug": "bone-broth-for-dogs-with-dental-issues"
  },
  {
    "name": "bone broth for dogs with hip dysplasia",
    "slug": "bone-broth-for-dogs-with-hip-dysplasia"
  },
  {
    "name": "bone broth for dogs with joint pain",
    "slug": "bone-broth-for-dogs-with-joint-pain"
  },
  {
    "name": "bone broth for dogs with mobility issues",
    "slug": "bone-broth-for-dogs-with-mobility-issues"
  },
  {
    "name": "bone broth for dogs with skin issues",
    "slug": "bone-broth-for-dogs-with-skin-issues"
  },
  {
    "name": "bone broth for dogs with digestive issues",
    "slug": "bone-broth-for-dogs-with-digestive-issues"
  },
  {
    "name": "bone broth for dogs with allergies",
    "slug": "bone-broth-for-dogs-with-allergies"
  },
  {
    "name": "bone broth for dogs with weight loss",
    "slug": "bone-broth-for-dogs-with-weight-loss"
  },
  {
    "name": "bone broth for dogs with poor appetite",
    "slug": "bone-broth-for-dogs-with-poor-appetite"
  },
  {
    "name": "bone broth for dogs with dehydration",
    "slug": "bone-broth-for-dogs-with-dehydration"
  },
  {
    "name": "bone broth for dogs with malnutrition",
    "slug": "bone-broth-for-dogs-with-malnutrition"
  },
  {
    "name": "bone broth for dogs with colitis",
    "slug": "bone-broth-for-dogs-with-colitis"
  },
  {
    "name": "bone broth for dogs with gastritis",
    "slug": "bone-broth-for-dogs-with-gastritis"
  },
  {
    "name": "bone broth for dogs with ulcers",
    "slug": "bone-broth-for-dogs-with-ulcers"
  },
  {
    "name": "bone broth for dogs with constipation",
    "slug": "bone-broth-for-dogs-with-constipation"
  },
  {
    "name": "bone broth for dogs with vomiting",
    "slug": "bone-broth-for-dogs-with-vomiting"
  },
  {
    "name": "bone broth for dogs with bloating",
    "slug": "bone-broth-for-dogs-with-bloating"
  },
  {
    "name": "bone broth for dogs with ear infections",
    "slug": "bone-broth-for-dogs-with-ear-infections"
  },
  {
    "name": "bone broth for dogs with yeast infections",
    "slug": "bone-broth-for-dogs-with-yeast-infections"
  },
  {
    "name": "bone broth for dogs with urinary tract infections",
    "slug": "bone-broth-for-dogs-with-urinary-tract-infections"
  },
  {
    "name": "bone broth for dogs with bladder stones",
    "slug": "bone-broth-for-dogs-with-bladder-stones"
  },
  {
    "name": "bone broth for dogs with kidney stones",
    "slug": "bone-broth-for-dogs-with-kidney-stones"
  },
  {
    "name": "bone broth for dogs with liver problems",
    "slug": "bone-broth-for-dogs-with-liver-problems"
  },
  {
    "name": "bone broth for dogs with heart problems",
    "slug": "bone-broth-for-dogs-with-heart-problems"
  },
  {
    "name": "bone broth for dogs with respiratory issues",
    "slug": "bone-broth-for-dogs-with-respiratory-issues"
  },
  {
    "name": "bone broth for dogs with anxiety",
    "slug": "bone-broth-for-dogs-with-anxiety"
  },
  {
    "name": "bone broth for dogs with stress",
    "slug": "bone-broth-for-dogs-with-stress"
  },
  {
    "name": "bone broth for dogs with behavioral issues",
    "slug": "bone-broth-for-dogs-with-behavioral-issues"
  },
  {
    "name": "cbd for dog seizures",
    "slug": "cbd-for-dog-seizures"
  },
  {
    "name": "cbd for dog seizures reviews",
    "slug": "cbd-for-dog-seizures-reviews"
  },
  {
    "name": "dog seizure symptoms",
    "slug": "dog-seizure-symptoms"
  },
  {
    "name": "dog epilepsy treatment",
    "slug": "dog-epilepsy-treatment"
  },
  {
    "name": "canine seizure causes",
    "slug": "canine-seizure-causes"
  },
  {
    "name": "dog seizure medication",
    "slug": "dog-seizure-medication"
  },
  {
    "name": "dog epilepsy causes",
    "slug": "dog-epilepsy-causes"
  },
  {
    "name": "canine epilepsy management",
    "slug": "canine-epilepsy-management"
  },
  {
    "name": "dog seizure management",
    "slug": "dog-seizure-management"
  },
  {
    "name": "dog epilepsy diagnosis",
    "slug": "dog-epilepsy-diagnosis"
  },
  {
    "name": "canine seizure treatment",
    "slug": "canine-seizure-treatment"
  },
  {
    "name": "dog seizure triggers",
    "slug": "dog-seizure-triggers"
  },
  {
    "name": "dog epilepsy symptoms",
    "slug": "dog-epilepsy-symptoms"
  },
  {
    "name": "canine epilepsy treatment",
    "slug": "canine-epilepsy-treatment"
  },
  {
    "name": "dog seizure causes",
    "slug": "dog-seizure-causes"
  },
  {
    "name": "dog epilepsy medication",
    "slug": "dog-epilepsy-medication"
  },
  {
    "name": "canine seizure disorders",
    "slug": "canine-seizure-disorders"
  },
  {
    "name": "dog seizure prevention",
    "slug": "dog-seizure-prevention"
  },
  {
    "name": "dog epilepsy management",
    "slug": "dog-epilepsy-management"
  },
  {
    "name": "canine seizure symptoms",
    "slug": "canine-seizure-symptoms"
  },
  {
    "name": "dog seizure diagnosis",
    "slug": "dog-seizure-diagnosis"
  },
  {
    "name": "dog epilepsy triggers",
    "slug": "dog-epilepsy-triggers"
  },
  {
    "name": "canine epilepsy causes",
    "slug": "canine-epilepsy-causes"
  },
  {
    "name": "dog seizure frequency",
    "slug": "dog-seizure-frequency"
  },
  {
    "name": "dog epilepsy prognosis",
    "slug": "dog-epilepsy-prognosis"
  },
  {
    "name": "canine seizure medication",
    "slug": "canine-seizure-medication"
  },
  {
    "name": "dog seizure monitoring",
    "slug": "dog-seizure-monitoring"
  },
  {
    "name": "dog epilepsy research",
    "slug": "dog-epilepsy-research"
  },
  {
    "name": "canine seizure management",
    "slug": "canine-seizure-management"
  },
  {
    "name": "dog seizure first-aid",
    "slug": "dog-seizure-first-aid"
  },
  {
    "name": "dog epilepsy support",
    "slug": "dog-epilepsy-support"
  },
  {
    "name": "canine seizure diagnosis",
    "slug": "canine-seizure-diagnosis"
  },
  {
    "name": "dog seizure control",
    "slug": "dog-seizure-control"
  },
  {
    "name": "dog epilepsy awareness",
    "slug": "dog-epilepsy-awareness"
  },
  {
    "name": "canine seizure prevention",
    "slug": "canine-seizure-prevention"
  },
  {
    "name": "dog seizure types",
    "slug": "dog-seizure-types"
  },
  {
    "name": "dog epilepsy information",
    "slug": "dog-epilepsy-information"
  },
  {
    "name": "canine seizure prognosis",
    "slug": "canine-seizure-prognosis"
  },
  {
    "name": "dog seizure recovery",
    "slug": "dog-seizure-recovery"
  },
  {
    "name": "dog epilepsy resources",
    "slug": "dog-epilepsy-resources"
  },
  {
    "name": "canine seizure triggers",
    "slug": "canine-seizure-triggers"
  },
  {
    "name": "dog seizure episodes",
    "slug": "dog-seizure-episodes"
  },
  {
    "name": "dog epilepsy statistics",
    "slug": "dog-epilepsy-statistics"
  },
  {
    "name": "canine seizure research",
    "slug": "canine-seizure-research"
  },
  {
    "name": "dog seizure emergency",
    "slug": "dog-seizure-emergency"
  },
  {
    "name": "dog epilepsy guidelines",
    "slug": "dog-epilepsy-guidelines"
  },
  {
    "name": "canine seizure awareness",
    "slug": "canine-seizure-awareness"
  },
  {
    "name": "dog seizure therapy",
    "slug": "dog-seizure-therapy"
  },
  {
    "name": "dog epilepsy monitoring",
    "slug": "dog-epilepsy-monitoring"
  },
  {
    "name": "canine seizure control",
    "slug": "canine-seizure-control"
  },
  {
    "name": "dog seizure diet",
    "slug": "dog-seizure-diet"
  },
  {
    "name": "dog epilepsy care",
    "slug": "dog-epilepsy-care"
  },
  {
    "name": "canine seizure information",
    "slug": "canine-seizure-information"
  },
  {
    "name": "dog seizure support",
    "slug": "dog-seizure-support"
  },
  {
    "name": "dog epilepsy causes",
    "slug": "dog-epilepsy-causes"
  },
  {
    "name": "canine seizure first-aid",
    "slug": "canine-seizure-first-aid"
  },
  {
    "name": "dog seizure treatment",
    "slug": "dog-seizure-treatment"
  },
  {
    "name": "dog epilepsy medication",
    "slug": "dog-epilepsy-medication"
  },
  {
    "name": "canine seizure disorders",
    "slug": "canine-seizure-disorders"
  },
  {
    "name": "dog seizure management",
    "slug": "dog-seizure-management"
  },
  {
    "name": "dog epilepsy diagnosis",
    "slug": "dog-epilepsy-diagnosis"
  },
  {
    "name": "canine seizure treatment",
    "slug": "canine-seizure-treatment"
  },
  {
    "name": "dog seizure triggers",
    "slug": "dog-seizure-triggers"
  },
  {
    "name": "dog epilepsy symptoms",
    "slug": "dog-epilepsy-symptoms"
  },
  {
    "name": "canine epilepsy treatment",
    "slug": "canine-epilepsy-treatment"
  },
  {
    "name": "dog seizure causes",
    "slug": "dog-seizure-causes"
  },
  {
    "name": "dog epilepsy medication",
    "slug": "dog-epilepsy-medication"
  },
  {
    "name": "canine seizure disorders",
    "slug": "canine-seizure-disorders"
  },
  {
    "name": "dog seizure prevention",
    "slug": "dog-seizure-prevention"
  },
  {
    "name": "dog epilepsy management",
    "slug": "dog-epilepsy-management"
  },
  {
    "name": "canine seizure symptoms",
    "slug": "canine-seizure-symptoms"
  },
  {
    "name": "dog seizure diagnosis",
    "slug": "dog-seizure-diagnosis"
  },
  {
    "name": "dog epilepsy triggers",
    "slug": "dog-epilepsy-triggers"
  },
  {
    "name": "canine epilepsy causes",
    "slug": "canine-epilepsy-causes"
  },
  {
    "name": "dog seizure frequency",
    "slug": "dog-seizure-frequency"
  },
  {
    "name": "dog epilepsy prognosis",
    "slug": "dog-epilepsy-prognosis"
  },
  {
    "name": "canine seizure medication",
    "slug": "canine-seizure-medication"
  },
  {
    "name": "dog seizure monitoring",
    "slug": "dog-seizure-monitoring"
  },
  {
    "name": "dog epilepsy research",
    "slug": "dog-epilepsy-research"
  },
  {
    "name": "canine seizure management",
    "slug": "canine-seizure-management"
  },
  {
    "name": "dog seizure first-aid",
    "slug": "dog-seizure-first-aid"
  },
  {
    "name": "dog epilepsy support",
    "slug": "dog-epilepsy-support"
  },
  {
    "name": "canine seizure diagnosis",
    "slug": "canine-seizure-diagnosis"
  },
  {
    "name": "dog seizure control",
    "slug": "dog-seizure-control"
  },
  {
    "name": "dog epilepsy awareness",
    "slug": "dog-epilepsy-awareness"
  },
  {
    "name": "canine seizure prevention",
    "slug": "canine-seizure-prevention"
  },
  {
    "name": "dog seizure types",
    "slug": "dog-seizure-types"
  },
  {
    "name": "dog epilepsy information",
    "slug": "dog-epilepsy-information"
  },
  {
    "name": "canine seizure prognosis",
    "slug": "canine-seizure-prognosis"
  },
  {
    "name": "dog seizure recovery",
    "slug": "dog-seizure-recovery"
  },
  {
    "name": "dog epilepsy resources",
    "slug": "dog-epilepsy-resources"
  },
  {
    "name": "canine seizure triggers",
    "slug": "canine-seizure-triggers"
  },
  {
    "name": "dog seizure episodes",
    "slug": "dog-seizure-episodes"
  },
  {
    "name": "dog epilepsy statistics",
    "slug": "dog-epilepsy-statistics"
  },
  {
    "name": "canine seizure research",
    "slug": "canine-seizure-research"
  },
  {
    "name": "dog seizure emergency",
    "slug": "dog-seizure-emergency"
  },
  {
    "name": "dog epilepsy guidelines",
    "slug": "dog-epilepsy-guidelines"
  },
  {
    "name": "canine seizure awareness",
    "slug": "canine-seizure-awareness"
  },
  {
    "name": "dog seizure therapy",
    "slug": "dog-seizure-therapy"
  },
  {
    "name": "dog epilepsy monitoring",
    "slug": "dog-epilepsy-monitoring"
  },
  {
    "name": "canine seizure control",
    "slug": "canine-seizure-control"
  },
  {
    "name": "dog seizure diet",
    "slug": "dog-seizure-diet"
  },
  {
    "name": "dog seizure symptoms and treatment",
    "slug": "dog-seizure-symptoms-and-treatment"
  },
  {
    "name": "dog epilepsy causes and management",
    "slug": "dog-epilepsy-causes-and-management"
  },
  {
    "name": "canine seizure disorders in dogs",
    "slug": "canine-seizure-disorders-in-dogs"
  },
  {
    "name": "dog seizure medication side effects",
    "slug": "dog-seizure-medication-side-effects"
  },
  {
    "name": "dog epilepsy diagnosis and treatment",
    "slug": "dog-epilepsy-diagnosis-and-treatment"
  },
  {
    "name": "canine seizure treatment options",
    "slug": "canine-seizure-treatment-options"
  },
  {
    "name": "dog seizure triggers and prevention",
    "slug": "dog-seizure-triggers-and-prevention"
  },
  {
    "name": "dog epilepsy symptoms and causes",
    "slug": "dog-epilepsy-symptoms-and-causes"
  },
  {
    "name": "canine epilepsy treatment in dogs",
    "slug": "canine-epilepsy-treatment-in-dogs"
  },
  {
    "name": "dog seizure causes and management",
    "slug": "dog-seizure-causes-and-management"
  },
  {
    "name": "dog epilepsy medication side effects",
    "slug": "dog-epilepsy-medication-side-effects"
  },
  {
    "name": "canine seizure disorders and treatment",
    "slug": "canine-seizure-disorders-and-treatment"
  },
  {
    "name": "dog seizure prevention and management",
    "slug": "dog-seizure-prevention-and-management"
  },
  {
    "name": "dog epilepsy management and care",
    "slug": "dog-epilepsy-management-and-care"
  },
  {
    "name": "canine seizure symptoms in dogs",
    "slug": "canine-seizure-symptoms-in-dogs"
  },
  {
    "name": "dog seizure diagnosis and treatment",
    "slug": "dog-seizure-diagnosis-and-treatment"
  },
  {
    "name": "dog epilepsy triggers and prevention",
    "slug": "dog-epilepsy-triggers-and-prevention"
  },
  {
    "name": "canine epilepsy causes and management",
    "slug": "canine-epilepsy-causes-and-management"
  },
  {
    "name": "dog seizure frequency and control",
    "slug": "dog-seizure-frequency-and-control"
  },
  {
    "name": "dog epilepsy prognosis and treatment",
    "slug": "dog-epilepsy-prognosis-and-treatment"
  },
  {
    "name": "canine seizure medication side effects",
    "slug": "canine-seizure-medication-side-effects"
  },
  {
    "name": "dog seizure monitoring and management",
    "slug": "dog-seizure-monitoring-and-management"
  },
  {
    "name": "dog epilepsy research and studies",
    "slug": "dog-epilepsy-research-and-studies"
  },
  {
    "name": "canine seizure management in dogs",
    "slug": "canine-seizure-management-in-dogs"
  },
  {
    "name": "dog seizure first-aid procedures",
    "slug": "dog-seizure-first-aid-procedures"
  },
  {
    "name": "dog epilepsy support and resources",
    "slug": "dog-epilepsy-support-and-resources"
  },
  {
    "name": "canine seizure diagnosis and treatment",
    "slug": "canine-seizure-diagnosis-and-treatment"
  },
  {
    "name": "dog seizure control and management",
    "slug": "dog-seizure-control-and-management"
  },
  {
    "name": "dog epilepsy awareness and education",
    "slug": "dog-epilepsy-awareness-and-education"
  },
  {
    "name": "canine seizure prevention in dogs",
    "slug": "canine-seizure-prevention-in-dogs"
  },
  {
    "name": "dog seizure types and symptoms",
    "slug": "dog-seizure-types-and-symptoms"
  },
  {
    "name": "dog epilepsy information and resources",
    "slug": "dog-epilepsy-information-and-resources"
  },
  {
    "name": "canine seizure prognosis and treatment",
    "slug": "canine-seizure-prognosis-and-treatment"
  },
  {
    "name": "dog seizure recovery and care",
    "slug": "dog-seizure-recovery-and-care"
  },
  {
    "name": "dog epilepsy resources and support",
    "slug": "dog-epilepsy-resources-and-support"
  },
  {
    "name": "canine seizure triggers and prevention",
    "slug": "canine-seizure-triggers-and-prevention"
  },
  {
    "name": "dog seizure episodes and management",
    "slug": "dog-seizure-episodes-and-management"
  },
  {
    "name": "dog epilepsy statistics and facts",
    "slug": "dog-epilepsy-statistics-and-facts"
  },
  {
    "name": "canine seizure research and studies",
    "slug": "canine-seizure-research-and-studies"
  },
  {
    "name": "dog seizure emergency treatment",
    "slug": "dog-seizure-emergency-treatment"
  },
  {
    "name": "dog epilepsy guidelines and protocols",
    "slug": "dog-epilepsy-guidelines-and-protocols"
  },
  {
    "name": "canine seizure awareness and education",
    "slug": "canine-seizure-awareness-and-education"
  },
  {
    "name": "dog seizure therapy and management",
    "slug": "dog-seizure-therapy-and-management"
  },
  {
    "name": "dog epilepsy monitoring and care",
    "slug": "dog-epilepsy-monitoring-and-care"
  },
  {
    "name": "canine seizure control in dogs",
    "slug": "canine-seizure-control-in-dogs"
  },
  {
    "name": "dog seizure diet and nutrition",
    "slug": "dog-seizure-diet-and-nutrition"
  },
  {
    "name": "dog epilepsy care and management",
    "slug": "dog-epilepsy-care-and-management"
  },
  {
    "name": "canine seizure information and resources",
    "slug": "canine-seizure-information-and-resources"
  },
  {
    "name": "dog seizure support and resources",
    "slug": "dog-seizure-support-and-resources"
  },
  {
    "name": "dog epilepsy causes and treatment",
    "slug": "dog-epilepsy-causes-and-treatment"
  },
  {
    "name": "canine seizure first-aid procedures",
    "slug": "canine-seizure-first-aid-procedures"
  },
  {
    "name": "dog seizure treatment and management",
    "slug": "dog-seizure-treatment-and-management"
  },
  {
    "name": "dog epilepsy medication and side effects",
    "slug": "dog-epilepsy-medication-and-side-effects"
  },
  {
    "name": "canine seizure disorders and management",
    "slug": "canine-seizure-disorders-and-management"
  },
  {
    "name": "dog seizure management and care",
    "slug": "dog-seizure-management-and-care"
  },
  {
    "name": "dog epilepsy diagnosis and management",
    "slug": "dog-epilepsy-diagnosis-and-management"
  },
  {
    "name": "canine seizure treatment and options",
    "slug": "canine-seizure-treatment-and-options"
  },
  {
    "name": "dog seizure triggers and management",
    "slug": "dog-seizure-triggers-and-management"
  },
  {
    "name": "dog epilepsy symptoms and treatment",
    "slug": "dog-epilepsy-symptoms-and-treatment"
  },
  {
    "name": "canine epilepsy treatment and management",
    "slug": "canine-epilepsy-treatment-and-management"
  },
  {
    "name": "dog seizure causes and treatment",
    "slug": "dog-seizure-causes-and-treatment"
  },
  {
    "name": "dog epilepsy medication and management",
    "slug": "dog-epilepsy-medication-and-management"
  },
  {
    "name": "canine seizure disorders and treatment",
    "slug": "canine-seizure-disorders-and-treatment"
  },
  {
    "name": "dog seizure prevention and care",
    "slug": "dog-seizure-prevention-and-care"
  },
  {
    "name": "dog epilepsy management and treatment",
    "slug": "dog-epilepsy-management-and-treatment"
  },
  {
    "name": "canine seizure symptoms and treatment",
    "slug": "canine-seizure-symptoms-and-treatment"
  },
  {
    "name": "dog seizure diagnosis and management",
    "slug": "dog-seizure-diagnosis-and-management"
  },
  {
    "name": "dog epilepsy triggers and management",
    "slug": "dog-epilepsy-triggers-and-management"
  },
  {
    "name": "canine epilepsy causes and treatment",
    "slug": "canine-epilepsy-causes-and-treatment"
  },
  {
    "name": "dog seizure frequency and management",
    "slug": "dog-seizure-frequency-and-management"
  },
  {
    "name": "dog epilepsy prognosis and management",
    "slug": "dog-epilepsy-prognosis-and-management"
  },
  {
    "name": "canine seizure medication and management",
    "slug": "canine-seizure-medication-and-management"
  },
  {
    "name": "dog seizure monitoring and care",
    "slug": "dog-seizure-monitoring-and-care"
  },
  {
    "name": "dog epilepsy research and findings",
    "slug": "dog-epilepsy-research-and-findings"
  },
  {
    "name": "canine seizure management and care",
    "slug": "canine-seizure-management-and-care"
  },
  {
    "name": "dog seizure first-aid and management",
    "slug": "dog-seizure-first-aid-and-management"
  },
  {
    "name": "dog epilepsy support and management",
    "slug": "dog-epilepsy-support-and-management"
  },
  {
    "name": "canine seizure diagnosis and management",
    "slug": "canine-seizure-diagnosis-and-management"
  },
  {
    "name": "dog seizure control and care",
    "slug": "dog-seizure-control-and-care"
  },
  {
    "name": "dog epilepsy awareness and support",
    "slug": "dog-epilepsy-awareness-and-support"
  },
  {
    "name": "canine seizure prevention and management",
    "slug": "canine-seizure-prevention-and-management"
  },
  {
    "name": "dog seizure types and treatment",
    "slug": "dog-seizure-types-and-treatment"
  },
  {
    "name": "dog epilepsy information and support",
    "slug": "dog-epilepsy-information-and-support"
  },
  {
    "name": "canine seizure prognosis and management",
    "slug": "canine-seizure-prognosis-and-management"
  },
  {
    "name": "dog seizure recovery and management",
    "slug": "dog-seizure-recovery-and-management"
  },
  {
    "name": "dog epilepsy resources and management",
    "slug": "dog-epilepsy-resources-and-management"
  },
  {
    "name": "canine seizure triggers and management",
    "slug": "canine-seizure-triggers-and-management"
  },
  {
    "name": "dog seizure episodes and treatment",
    "slug": "dog-seizure-episodes-and-treatment"
  },
  {
    "name": "dog epilepsy statistics and management",
    "slug": "dog-epilepsy-statistics-and-management"
  },
  {
    "name": "canine seizure research and findings",
    "slug": "canine-seizure-research-and-findings"
  },
  {
    "name": "dog seizure emergency and management",
    "slug": "dog-seizure-emergency-and-management"
  },
  {
    "name": "dog epilepsy guidelines and management",
    "slug": "dog-epilepsy-guidelines-and-management"
  },
  {
    "name": "canine seizure awareness and support",
    "slug": "canine-seizure-awareness-and-support"
  },
  {
    "name": "dog seizure therapy and treatment",
    "slug": "dog-seizure-therapy-and-treatment"
  },
  {
    "name": "dog epilepsy monitoring and management",
    "slug": "dog-epilepsy-monitoring-and-management"
  },
  {
    "name": "canine seizure control and management",
    "slug": "canine-seizure-control-and-management"
  },
  {
    "name": "dog seizure diet and management",
    "slug": "dog-seizure-diet-and-management"
  },
  {
    "name": "dog epilepsy care and support",
    "slug": "dog-epilepsy-care-and-support"
  },
  {
    "name": "canine seizure information and management",
    "slug": "canine-seizure-information-and-management"
  },
  {
    "name": "dog seizure support and management",
    "slug": "dog-seizure-support-and-management"
  },
  {
    "name": "dog epilepsy causes and prevention",
    "slug": "dog-epilepsy-causes-and-prevention"
  },
  {
    "name": "canine seizure first-aid and management",
    "slug": "canine-seizure-first-aid-and-management"
  },
  {
    "name": "dog seizure treatment and care",
    "slug": "dog-seizure-treatment-and-care"
  },
  {
    "name": "dog epilepsy medication and treatment",
    "slug": "dog-epilepsy-medication-and-treatment"
  },
  {
    "name": "canine seizure disorders and care",
    "slug": "canine-seizure-disorders-and-care"
  },
  {
    "name": "dog seizure management and support",
    "slug": "dog-seizure-management-and-support"
  },
  {
    "name": "dog epilepsy diagnosis and care",
    "slug": "dog-epilepsy-diagnosis-and-care"
  },
  {
    "name": "cbd for dogs aggression",
    "slug": "cbd-for-dogs-aggression"
  },
  {
    "name": "cbd for aggressive dogs",
    "slug": "cbd-for-aggressive-dogs"
  },
  {
    "name": "cbd for dogs with seizures",
    "slug": "cbd-for-dogs-with-seizures"
  },
  {
    "name": "dog aggression training",
    "slug": "dog-aggression-training"
  },
  {
    "name": "aggressive dog behavior",
    "slug": "aggressive-dog-behavior"
  },
  {
    "name": "dog aggression causes",
    "slug": "dog-aggression-causes"
  },
  {
    "name": "dog aggression solutions",
    "slug": "dog-aggression-solutions"
  },
  {
    "name": "canine aggression management",
    "slug": "canine-aggression-management"
  },
  {
    "name": "dog aggression signs",
    "slug": "dog-aggression-signs"
  },
  {
    "name": "aggressive dog rehabilitation",
    "slug": "aggressive-dog-rehabilitation"
  },
  {
    "name": "dog aggression prevention",
    "slug": "dog-aggression-prevention"
  },
  {
    "name": "canine aggression treatment",
    "slug": "canine-aggression-treatment"
  },
  {
    "name": "dog aggression triggers",
    "slug": "dog-aggression-triggers"
  },
  {
    "name": "aggressive dog handling",
    "slug": "aggressive-dog-handling"
  },
  {
    "name": "dog aggression therapy",
    "slug": "dog-aggression-therapy"
  },
  {
    "name": "canine aggression symptoms",
    "slug": "canine-aggression-symptoms"
  },
  {
    "name": "dog aggression rehabilitation",
    "slug": "dog-aggression-rehabilitation"
  },
  {
    "name": "aggressive dog management",
    "slug": "aggressive-dog-management"
  },
  {
    "name": "dog aggression modification",
    "slug": "dog-aggression-modification"
  },
  {
    "name": "canine aggression training",
    "slug": "canine-aggression-training"
  },
  {
    "name": "dog aggression control",
    "slug": "dog-aggression-control"
  },
  {
    "name": "aggressive dog treatment",
    "slug": "aggressive-dog-treatment"
  },
  {
    "name": "dog aggression behavior",
    "slug": "dog-aggression-behavior"
  },
  {
    "name": "aggressive dog training",
    "slug": "aggressive-dog-training"
  },
  {
    "name": "dog aggression issues",
    "slug": "dog-aggression-issues"
  },
  {
    "name": "canine aggression prevention",
    "slug": "canine-aggression-prevention"
  },
  {
    "name": "dog aggression assessment",
    "slug": "dog-aggression-assessment"
  },
  {
    "name": "aggressive dog therapy",
    "slug": "aggressive-dog-therapy"
  },
  {
    "name": "dog aggression intervention",
    "slug": "dog-aggression-intervention"
  },
  {
    "name": "canine aggression rehabilitation",
    "slug": "canine-aggression-rehabilitation"
  },
  {
    "name": "dog aggression counseling",
    "slug": "dog-aggression-counseling"
  },
  {
    "name": "aggressive dog solutions",
    "slug": "aggressive-dog-solutions"
  },
  {
    "name": "dog aggression evaluation",
    "slug": "dog-aggression-evaluation"
  },
  {
    "name": "canine aggression modification",
    "slug": "canine-aggression-modification"
  },
  {
    "name": "dog aggression support",
    "slug": "dog-aggression-support"
  },
  {
    "name": "aggressive dog assessment",
    "slug": "aggressive-dog-assessment"
  },
  {
    "name": "dog aggression correction",
    "slug": "dog-aggression-correction"
  },
  {
    "name": "canine aggression intervention",
    "slug": "canine-aggression-intervention"
  },
  {
    "name": "dog aggression advice",
    "slug": "dog-aggression-advice"
  },
  {
    "name": "aggressive dog counseling",
    "slug": "aggressive-dog-counseling"
  },
  {
    "name": "dog aggression expertise",
    "slug": "dog-aggression-expertise"
  },
  {
    "name": "canine aggression correction",
    "slug": "canine-aggression-correction"
  },
  {
    "name": "dog aggression guidance",
    "slug": "dog-aggression-guidance"
  },
  {
    "name": "aggressive dog support",
    "slug": "aggressive-dog-support"
  },
  {
    "name": "dog aggression strategies",
    "slug": "dog-aggression-strategies"
  },
  {
    "name": "canine aggression advice",
    "slug": "canine-aggression-advice"
  },
  {
    "name": "dog aggression techniques",
    "slug": "dog-aggression-techniques"
  },
  {
    "name": "aggressive dog guidance",
    "slug": "aggressive-dog-guidance"
  },
  {
    "name": "dog aggression programs",
    "slug": "dog-aggression-programs"
  },
  {
    "name": "canine aggression expertise",
    "slug": "canine-aggression-expertise"
  },
  {
    "name": "dog aggression courses",
    "slug": "dog-aggression-courses"
  },
  {
    "name": "aggressive dog programs",
    "slug": "aggressive-dog-programs"
  },
  {
    "name": "canine aggression support",
    "slug": "canine-aggression-support"
  },
  {
    "name": "dog aggression training techniques",
    "slug": "dog-aggression-training-techniques"
  },
  {
    "name": "how to train aggressive dogs",
    "slug": "how-to-train-aggressive-dogs"
  },
  {
    "name": "managing aggressive dog behavior",
    "slug": "managing-aggressive-dog-behavior"
  },
  {
    "name": "dog aggression signs and symptoms",
    "slug": "dog-aggression-signs-and-symptoms"
  },
  {
    "name": "effective aggressive dog training",
    "slug": "effective-aggressive-dog-training"
  },
  {
    "name": "understanding canine aggressive behavior",
    "slug": "understanding-canine-aggressive-behavior"
  },
  {
    "name": "dog aggression causes and solutions",
    "slug": "dog-aggression-causes-and-solutions"
  },
  {
    "name": "training tips for aggressive dogs",
    "slug": "training-tips-for-aggressive-dogs"
  },
  {
    "name": "dog aggression towards other dogs",
    "slug": "dog-aggression-towards-other-dogs"
  },
  {
    "name": "canine aggression management strategies",
    "slug": "canine-aggression-management-strategies"
  },
  {
    "name": "dog aggression towards strangers",
    "slug": "dog-aggression-towards-strangers"
  },
  {
    "name": "aggressive dog behavior modification",
    "slug": "aggressive-dog-behavior-modification"
  },
  {
    "name": "dog aggression towards children",
    "slug": "dog-aggression-towards-children"
  },
  {
    "name": "canine aggression treatment options",
    "slug": "canine-aggression-treatment-options"
  },
  {
    "name": "dog aggression towards owners",
    "slug": "dog-aggression-towards-owners"
  },
  {
    "name": "aggressive dog rehabilitation programs",
    "slug": "aggressive-dog-rehabilitation-programs"
  },
  {
    "name": "dog aggression towards visitors",
    "slug": "dog-aggression-towards-visitors"
  },
  {
    "name": "canine aggression prevention methods",
    "slug": "canine-aggression-prevention-methods"
  },
  {
    "name": "dog aggression towards animals",
    "slug": "dog-aggression-towards-animals"
  },
  {
    "name": "aggressive dog handling techniques",
    "slug": "aggressive-dog-handling-techniques"
  },
  {
    "name": "dog aggression towards mail carriers",
    "slug": "dog-aggression-towards-mail-carriers"
  },
  {
    "name": "canine aggression therapy approaches",
    "slug": "canine-aggression-therapy-approaches"
  },
  {
    "name": "dog aggression towards neighbors",
    "slug": "dog-aggression-towards-neighbors"
  },
  {
    "name": "aggressive dog management plans",
    "slug": "aggressive-dog-management-plans"
  },
  {
    "name": "dog aggression towards delivery personnel",
    "slug": "dog-aggression-towards-delivery-personnel"
  },
  {
    "name": "canine aggression behavior assessment",
    "slug": "canine-aggression-behavior-assessment"
  },
  {
    "name": "dog aggression towards joggers",
    "slug": "dog-aggression-towards-joggers"
  },
  {
    "name": "aggressive dog training classes",
    "slug": "aggressive-dog-training-classes"
  },
  {
    "name": "dog aggression towards cyclists",
    "slug": "dog-aggression-towards-cyclists"
  },
  {
    "name": "canine aggression intervention strategies",
    "slug": "canine-aggression-intervention-strategies"
  },
  {
    "name": "dog aggression towards veterinarians",
    "slug": "dog-aggression-towards-veterinarians"
  },
  {
    "name": "aggressive dog behavior counseling",
    "slug": "aggressive-dog-behavior-counseling"
  },
  {
    "name": "dog aggression towards groomers",
    "slug": "dog-aggression-towards-groomers"
  },
  {
    "name": "canine aggression modification programs",
    "slug": "canine-aggression-modification-programs"
  },
  {
    "name": "dog aggression towards guests",
    "slug": "dog-aggression-towards-guests"
  },
  {
    "name": "aggressive dog behavior therapy",
    "slug": "aggressive-dog-behavior-therapy"
  },
  {
    "name": "dog aggression towards family members",
    "slug": "dog-aggression-towards-family-members"
  },
  {
    "name": "canine aggression support services",
    "slug": "canine-aggression-support-services"
  },
  {
    "name": "dog aggression towards pets",
    "slug": "dog-aggression-towards-pets"
  },
  {
    "name": "aggressive dog behavior assessment",
    "slug": "aggressive-dog-behavior-assessment"
  },
  {
    "name": "dog aggression towards livestock",
    "slug": "dog-aggression-towards-livestock"
  },
  {
    "name": "canine aggression correction techniques",
    "slug": "canine-aggression-correction-techniques"
  },
  {
    "name": "dog aggression towards wildlife",
    "slug": "dog-aggression-towards-wildlife"
  },
  {
    "name": "aggressive dog behavior intervention",
    "slug": "aggressive-dog-behavior-intervention"
  },
  {
    "name": "dog aggression towards vehicles",
    "slug": "dog-aggression-towards-vehicles"
  },
  {
    "name": "canine aggression guidance resources",
    "slug": "canine-aggression-guidance-resources"
  },
  {
    "name": "dog aggression towards bicycles",
    "slug": "dog-aggression-towards-bicycles"
  },
  {
    "name": "aggressive dog behavior correction",
    "slug": "aggressive-dog-behavior-correction"
  },
  {
    "name": "dog aggression towards skateboards",
    "slug": "dog-aggression-towards-skateboards"
  },
  {
    "name": "canine aggression training programs",
    "slug": "canine-aggression-training-programs"
  },
  {
    "name": "dog aggression towards scooters",
    "slug": "dog-aggression-towards-scooters"
  },
  {
    "name": "aggressive dog behavior modification techniques",
    "slug": "aggressive-dog-behavior-modification-techniques"
  },
  {
    "name": "dog aggression towards motorcycles",
    "slug": "dog-aggression-towards-motorcycles"
  },
  {
    "name": "canine aggression control methods",
    "slug": "canine-aggression-control-methods"
  },
  {
    "name": "aggressive dog behavior management strategies",
    "slug": "aggressive-dog-behavior-management-strategies"
  },
  {
    "name": "hemp oil vs cbd oil for cats",
    "slug": "hemp-oil-vs-cbd-oil-for-cats"
  },
  {
    "name": "calming cbd for cats",
    "slug": "calming-cbd-for-cats"
  },
  {
    "name": "calming cbd treats for cats",
    "slug": "calming-cbd-treats-for-cats"
  },
  {
    "name": "cbd calming cat treats",
    "slug": "cbd-calming-cat-treats"
  },
  {
    "name": "cbd for cats with anxiety",
    "slug": "cbd-for-cats-with-anxiety"
  },
  {
    "name": "cat cbd for anxiety",
    "slug": "cat-cbd-for-anxiety"
  },
  {
    "name": "cat anxiety symptoms",
    "slug": "cat-anxiety-symptoms"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety signs",
    "slug": "cat-anxiety-signs"
  },
  {
    "name": "cat anxiety relief",
    "slug": "cat-anxiety-relief"
  },
  {
    "name": "cat anxiety causes",
    "slug": "cat-anxiety-causes"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "cat anxiety signs",
    "slug": "cat-anxiety-signs"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "cat anxiety causes",
    "slug": "cat-anxiety-causes"
  },
  {
    "name": "cat anxiety relief",
    "slug": "cat-anxiety-relief"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "cat anxiety causes",
    "slug": "cat-anxiety-causes"
  },
  {
    "name": "cat anxiety relief",
    "slug": "cat-anxiety-relief"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "cat anxiety causes",
    "slug": "cat-anxiety-causes"
  },
  {
    "name": "cat anxiety relief",
    "slug": "cat-anxiety-relief"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "cat anxiety causes",
    "slug": "cat-anxiety-causes"
  },
  {
    "name": "cat anxiety relief",
    "slug": "cat-anxiety-relief"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "cat anxiety causes",
    "slug": "cat-anxiety-causes"
  },
  {
    "name": "cat anxiety relief",
    "slug": "cat-anxiety-relief"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "cat anxiety causes",
    "slug": "cat-anxiety-causes"
  },
  {
    "name": "cat anxiety relief",
    "slug": "cat-anxiety-relief"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "cat anxiety causes",
    "slug": "cat-anxiety-causes"
  },
  {
    "name": "cat anxiety relief",
    "slug": "cat-anxiety-relief"
  },
  {
    "name": "cat anxiety solutions",
    "slug": "cat-anxiety-solutions"
  },
  {
    "name": "cat anxiety medication",
    "slug": "cat-anxiety-medication"
  },
  {
    "name": "cat anxiety treatment",
    "slug": "cat-anxiety-treatment"
  },
  {
    "name": "cat anxiety remedies",
    "slug": "cat-anxiety-remedies"
  },
  {
    "name": "cat anxiety products",
    "slug": "cat-anxiety-products"
  },
  {
    "name": "cat anxiety help",
    "slug": "cat-anxiety-help"
  },
  {
    "name": "cat anxiety management",
    "slug": "cat-anxiety-management"
  },
  {
    "name": "cat anxiety disorder",
    "slug": "cat-anxiety-disorder"
  },
  {
    "name": "cat anxiety toys",
    "slug": "cat-anxiety-toys"
  },
  {
    "name": "feline anxiety causes and symptoms",
    "slug": "feline-anxiety-causes-and-symptoms"
  },
  {
    "name": "feline anxiety relief and solutions",
    "slug": "feline-anxiety-relief-and-solutions"
  },
  {
    "name": "cat anxiety medication side effects",
    "slug": "cat-anxiety-medication-side-effects"
  },
  {
    "name": "feline anxiety treatment options available",
    "slug": "feline-anxiety-treatment-options-available"
  },
  {
    "name": "feline anxiety relief and treatment",
    "slug": "feline-anxiety-relief-and-treatment"
  },
  {
    "name": "cat anxiety calming behavioral solutions",
    "slug": "cat-anxiety-calming-behavioral-solutions"
  },
  {
    "name": "feline anxiety symptoms and signs",
    "slug": "feline-anxiety-symptoms-and-signs"
  },
  {
    "name": "feline anxiety triggers and management",
    "slug": "feline-anxiety-triggers-and-management"
  },
  {
    "name": "feline anxiety prevention and control",
    "slug": "feline-anxiety-prevention-and-control"
  },
  {
    "name": "feline anxiety holistic treatment strategies",
    "slug": "feline-anxiety-holistic-treatment-strategies"
  },
  {
    "name": "feline anxiety natural relief methods",
    "slug": "feline-anxiety-natural-relief-methods"
  },
  {
    "name": "feline anxiety calming product options",
    "slug": "feline-anxiety-calming-product-options"
  },
  {
    "name": "cat anxiety calming product selection",
    "slug": "cat-anxiety-calming-product-selection"
  },
  {
    "name": "feline anxiety calming treatment solutions",
    "slug": "feline-anxiety-calming-treatment-solutions"
  },
  {
    "name": "feline anxiety management treatment plans",
    "slug": "feline-anxiety-management-treatment-plans"
  },
  {
    "name": "cat anxiety medication support solutions",
    "slug": "cat-anxiety-medication-support-solutions"
  },
  {
    "name": "feline anxiety medication treatment strategies",
    "slug": "feline-anxiety-medication-treatment-strategies"
  },
  {
    "name": "cat anxiety behavioral therapy programs",
    "slug": "cat-anxiety-behavioral-therapy-programs"
  },
  {
    "name": "feline anxiety natural lifestyle adjustments",
    "slug": "feline-anxiety-natural-lifestyle-adjustments"
  },
  {
    "name": "feline anxiety stress management approaches",
    "slug": "feline-anxiety-stress-management-approaches"
  },
  {
    "name": "feline anxiety calming behavioral plans",
    "slug": "feline-anxiety-calming-behavioral-plans"
  },
  {
    "name": "cat anxiety calming supportive methods",
    "slug": "cat-anxiety-calming-supportive-methods"
  },
  {
    "name": "feline anxiety supportive lifestyle changes",
    "slug": "feline-anxiety-supportive-lifestyle-changes"
  },
  {
    "name": "feline anxiety natural calming adjustments",
    "slug": "feline-anxiety-natural-calming-adjustments"
  },
  {
    "name": "cat anxiety natural therapeutic options",
    "slug": "cat-anxiety-natural-therapeutic-options"
  },
  {
    "name": "feline anxiety behavior adjustment therapies",
    "slug": "feline-anxiety-behavior-adjustment-therapies"
  },
  {
    "name": "feline anxiety medication therapy programs",
    "slug": "feline-anxiety-medication-therapy-programs"
  },
  {
    "name": "cat anxiety calming therapeutic solutions",
    "slug": "cat-anxiety-calming-therapeutic-solutions"
  },
  {
    "name": "feline anxiety calming aid strategies",
    "slug": "feline-anxiety-calming-aid-strategies"
  },
  {
    "name": "feline anxiety stress relief therapies",
    "slug": "feline-anxiety-stress-relief-therapies"
  },
  {
    "name": "feline anxiety behavior modification support",
    "slug": "feline-anxiety-behavior-modification-support"
  },
  {
    "name": "feline anxiety calming therapy strategies",
    "slug": "feline-anxiety-calming-therapy-strategies"
  },
  {
    "name": "feline anxiety calming intervention plans",
    "slug": "feline-anxiety-calming-intervention-plans"
  },
  {
    "name": "feline anxiety calming adjustment therapies",
    "slug": "feline-anxiety-calming-adjustment-therapies"
  },
  {
    "name": "feline anxiety supportive therapeutic solutions",
    "slug": "feline-anxiety-supportive-therapeutic-solutions"
  },
  {
    "name": "feline anxiety calming behavior therapy",
    "slug": "feline-anxiety-calming-behavior-therapy"
  },
  {
    "name": "feline anxiety medication therapeutic plans",
    "slug": "feline-anxiety-medication-therapeutic-plans"
  },
  {
    "name": "feline anxiety behavioral therapy techniques",
    "slug": "feline-anxiety-behavioral-therapy-techniques"
  },
  {
    "name": "feline anxiety calming supportive treatments",
    "slug": "feline-anxiety-calming-supportive-treatments"
  },
  {
    "name": "feline anxiety behavior lifestyle management",
    "slug": "feline-anxiety-behavior-lifestyle-management"
  },
  {
    "name": "feline anxiety stress relief plans",
    "slug": "feline-anxiety-stress-relief-plans"
  },
  {
    "name": "feline anxiety behavioral adjustment plans",
    "slug": "feline-anxiety-behavioral-adjustment-plans"
  },
  {
    "name": "feline anxiety calming therapeutic approaches",
    "slug": "feline-anxiety-calming-therapeutic-approaches"
  },
  {
    "name": "feline anxiety medication therapy plans",
    "slug": "feline-anxiety-medication-therapy-plans"
  },
  {
    "name": "feline anxiety calming therapeutic programs",
    "slug": "feline-anxiety-calming-therapeutic-programs"
  },
  {
    "name": "feline anxiety supportive treatment options",
    "slug": "feline-anxiety-supportive-treatment-options"
  },
  {
    "name": "feline anxiety medication adjustment support",
    "slug": "feline-anxiety-medication-adjustment-support"
  },
  {
    "name": "feline anxiety calming therapy techniques",
    "slug": "feline-anxiety-calming-therapy-techniques"
  },
  {
    "name": "feline anxiety adjustment behavioral solutions",
    "slug": "feline-anxiety-adjustment-behavioral-solutions"
  },
  {
    "name": "feline anxiety calming supportive therapies",
    "slug": "feline-anxiety-calming-supportive-therapies"
  },
  {
    "name": "feline anxiety management therapeutic treatments",
    "slug": "feline-anxiety-management-therapeutic-treatments"
  },
  {
    "name": "feline anxiety adjustment calming therapies",
    "slug": "feline-anxiety-adjustment-calming-therapies"
  },
  {
    "name": "feline anxiety behavioral calming interventions",
    "slug": "feline-anxiety-behavioral-calming-interventions"
  },
  {
    "name": "feline anxiety calming therapeutic management",
    "slug": "feline-anxiety-calming-therapeutic-management"
  },
  {
    "name": "feline anxiety lifestyle adjustment treatments",
    "slug": "feline-anxiety-lifestyle-adjustment-treatments"
  },
  {
    "name": "feline anxiety calming behavioral treatments",
    "slug": "feline-anxiety-calming-behavioral-treatments"
  },
  {
    "name": "feline anxiety calming lifestyle solutions",
    "slug": "feline-anxiety-calming-lifestyle-solutions"
  },
  {
    "name": "feline anxiety adjustment therapeutic support",
    "slug": "feline-anxiety-adjustment-therapeutic-support"
  },
  {
    "name": "feline anxiety medication therapy treatments",
    "slug": "feline-anxiety-medication-therapy-treatments"
  },
  {
    "name": "feline anxiety lifestyle therapeutic options",
    "slug": "feline-anxiety-lifestyle-therapeutic-options"
  },
  {
    "name": "feline anxiety behavioral management programs",
    "slug": "feline-anxiety-behavioral-management-programs"
  },
  {
    "name": "feline anxiety calming intervention therapies",
    "slug": "feline-anxiety-calming-intervention-therapies"
  },
  {
    "name": "feline anxiety behavioral therapeutic strategies",
    "slug": "feline-anxiety-behavioral-therapeutic-strategies"
  },
  {
    "name": "feline anxiety calming behavior techniques",
    "slug": "feline-anxiety-calming-behavior-techniques"
  },
  {
    "name": "feline anxiety stress reduction adjustments",
    "slug": "feline-anxiety-stress-reduction-adjustments"
  },
  {
    "name": "feline anxiety therapeutic calming techniques",
    "slug": "feline-anxiety-therapeutic-calming-techniques"
  },
  {
    "name": "feline anxiety therapeutic adjustment treatments",
    "slug": "feline-anxiety-therapeutic-adjustment-treatments"
  },
  {
    "name": "feline anxiety adjustment lifestyle therapies",
    "slug": "feline-anxiety-adjustment-lifestyle-therapies"
  },
  {
    "name": "feline anxiety calming treatment interventions",
    "slug": "feline-anxiety-calming-treatment-interventions"
  },
  {
    "name": "feline anxiety therapeutic support solutions",
    "slug": "feline-anxiety-therapeutic-support-solutions"
  },
  {
    "name": "cat cbd for arthritis pain",
    "slug": "cat-cbd-for-arthritis-pain"
  },
  {
    "name": "cbd for cats arthritis",
    "slug": "cbd-for-cats-arthritis"
  },
  {
    "name": "cbd for cats pain",
    "slug": "cbd-for-cats-pain"
  },
  {
    "name": "cat joint pain",
    "slug": "cat-joint-pain"
  },
  {
    "name": "cat hip pain",
    "slug": "cat-hip-pain"
  },
  {
    "name": "cat arthritis symptoms",
    "slug": "cat-arthritis-symptoms"
  },
  {
    "name": "cat joint supplements",
    "slug": "cat-joint-supplements"
  },
  {
    "name": "cat hip dysplasia",
    "slug": "cat-hip-dysplasia"
  },
  {
    "name": "cat arthritis medication",
    "slug": "cat-arthritis-medication"
  },
  {
    "name": "cat joint inflammation",
    "slug": "cat-joint-inflammation"
  },
  {
    "name": "cat hip arthritis",
    "slug": "cat-hip-arthritis"
  },
  {
    "name": "cat arthritis treatment",
    "slug": "cat-arthritis-treatment"
  },
  {
    "name": "cat joint stiffness",
    "slug": "cat-joint-stiffness"
  },
  {
    "name": "cat hip problems",
    "slug": "cat-hip-problems"
  },
  {
    "name": "cat arthritis relief",
    "slug": "cat-arthritis-relief"
  },
  {
    "name": "cat joint issues",
    "slug": "cat-joint-issues"
  },
  {
    "name": "cat hip pain",
    "slug": "cat-hip-pain"
  },
  {
    "name": "cat arthritis management",
    "slug": "cat-arthritis-management"
  },
  {
    "name": "cat joint discomfort",
    "slug": "cat-joint-discomfort"
  },
  {
    "name": "cat hip inflammation",
    "slug": "cat-hip-inflammation"
  },
  {
    "name": "cat arthritis remedies",
    "slug": "cat-arthritis-remedies"
  },
  {
    "name": "cat joint support",
    "slug": "cat-joint-support"
  },
  {
    "name": "cat hip stiffness",
    "slug": "cat-hip-stiffness"
  },
  {
    "name": "cat arthritis diagnosis",
    "slug": "cat-arthritis-diagnosis"
  },
  {
    "name": "cat joint health",
    "slug": "cat-joint-health"
  },
  {
    "name": "cat hip issues",
    "slug": "cat-hip-issues"
  },
  {
    "name": "cat arthritis therapy",
    "slug": "cat-arthritis-therapy"
  },
  {
    "name": "cat joint degeneration",
    "slug": "cat-joint-degeneration"
  },
  {
    "name": "cat hip discomfort",
    "slug": "cat-hip-discomfort"
  },
  {
    "name": "cat arthritis pain",
    "slug": "cat-arthritis-pain"
  },
  {
    "name": "cat joint disease",
    "slug": "cat-joint-disease"
  },
  {
    "name": "cat hip support",
    "slug": "cat-hip-support"
  },
  {
    "name": "cat arthritis supplements",
    "slug": "cat-arthritis-supplements"
  },
  {
    "name": "cat joint mobility",
    "slug": "cat-joint-mobility"
  },
  {
    "name": "cat hip treatment",
    "slug": "cat-hip-treatment"
  },
  {
    "name": "cat arthritis causes",
    "slug": "cat-arthritis-causes"
  },
  {
    "name": "cat joint pain relief",
    "slug": "cat-joint-pain-relief"
  },
  {
    "name": "cat hip problems",
    "slug": "cat-hip-problems"
  },
  {
    "name": "cat arthritis medication",
    "slug": "cat-arthritis-medication"
  },
  {
    "name": "cat joint inflammation",
    "slug": "cat-joint-inflammation"
  },
  {
    "name": "cat hip arthritis",
    "slug": "cat-hip-arthritis"
  },
  {
    "name": "cat arthritis treatment",
    "slug": "cat-arthritis-treatment"
  },
  {
    "name": "cat joint stiffness",
    "slug": "cat-joint-stiffness"
  },
  {
    "name": "cat hip issues",
    "slug": "cat-hip-issues"
  },
  {
    "name": "cat arthritis management",
    "slug": "cat-arthritis-management"
  },
  {
    "name": "cat joint discomfort",
    "slug": "cat-joint-discomfort"
  },
  {
    "name": "cat hip inflammation",
    "slug": "cat-hip-inflammation"
  },
  {
    "name": "cat arthritis remedies",
    "slug": "cat-arthritis-remedies"
  },
  {
    "name": "cat joint support",
    "slug": "cat-joint-support"
  },
  {
    "name": "cat hip stiffness",
    "slug": "cat-hip-stiffness"
  },
  {
    "name": "cat arthritis diagnosis",
    "slug": "cat-arthritis-diagnosis"
  },
  {
    "name": "cat joint health",
    "slug": "cat-joint-health"
  },
  {
    "name": "cat hip discomfort",
    "slug": "cat-hip-discomfort"
  },
  {
    "name": "feline joint pain relief",
    "slug": "feline-joint-pain-relief"
  },
  {
    "name": "feline hip dysplasia treatment",
    "slug": "feline-hip-dysplasia-treatment"
  },
  {
    "name": "feline arthritis pain management",
    "slug": "feline-arthritis-pain-management"
  },
  {
    "name": "cat joint pain remedies",
    "slug": "cat-joint-pain-remedies"
  },
  {
    "name": "cat hip pain relief",
    "slug": "cat-hip-pain-relief"
  },
  {
    "name": "cat arthritis natural treatments",
    "slug": "cat-arthritis-natural-treatments"
  },
  {
    "name": "feline joint health supplements",
    "slug": "feline-joint-health-supplements"
  },
  {
    "name": "feline hip arthritis symptoms",
    "slug": "feline-hip-arthritis-symptoms"
  },
  {
    "name": "feline arthritis treatment options",
    "slug": "feline-arthritis-treatment-options"
  },
  {
    "name": "cat joint pain medication",
    "slug": "cat-joint-pain-medication"
  },
  {
    "name": "cat hip joint issues",
    "slug": "cat-hip-joint-issues"
  },
  {
    "name": "cat arthritis pain relief",
    "slug": "cat-arthritis-pain-relief"
  },
  {
    "name": "feline joint inflammation causes",
    "slug": "feline-joint-inflammation-causes"
  },
  {
    "name": "feline hip pain management",
    "slug": "feline-hip-pain-management"
  },
  {
    "name": "feline arthritis symptoms in cats",
    "slug": "feline-arthritis-symptoms-in-cats"
  },
  {
    "name": "cat joint support supplements",
    "slug": "cat-joint-support-supplements"
  },
  {
    "name": "cat hip dysplasia symptoms",
    "slug": "cat-hip-dysplasia-symptoms"
  },
  {
    "name": "cat arthritis treatment options",
    "slug": "cat-arthritis-treatment-options"
  },
  {
    "name": "feline joint stiffness remedies",
    "slug": "feline-joint-stiffness-remedies"
  },
  {
    "name": "feline hip joint pain",
    "slug": "feline-hip-joint-pain"
  },
  {
    "name": "feline arthritis management strategies",
    "slug": "feline-arthritis-management-strategies"
  },
  {
    "name": "cat joint health products",
    "slug": "cat-joint-health-products"
  },
  {
    "name": "cat hip pain management",
    "slug": "cat-hip-pain-management"
  },
  {
    "name": "cat arthritis pain management",
    "slug": "cat-arthritis-pain-management"
  },
  {
    "name": "feline joint pain symptoms",
    "slug": "feline-joint-pain-symptoms"
  },
  {
    "name": "feline hip arthritis treatment",
    "slug": "feline-hip-arthritis-treatment"
  },
  {
    "name": "feline arthritis natural remedies",
    "slug": "feline-arthritis-natural-remedies"
  },
  {
    "name": "cat joint inflammation treatment",
    "slug": "cat-joint-inflammation-treatment"
  },
  {
    "name": "cat hip joint problems",
    "slug": "cat-hip-joint-problems"
  },
  {
    "name": "cat arthritis support supplements",
    "slug": "cat-arthritis-support-supplements"
  },
  {
    "name": "feline joint pain causes",
    "slug": "feline-joint-pain-causes"
  },
  {
    "name": "feline hip dysplasia management",
    "slug": "feline-hip-dysplasia-management"
  },
  {
    "name": "feline arthritis pain relief",
    "slug": "feline-arthritis-pain-relief"
  },
  {
    "name": "cat joint stiffness treatment",
    "slug": "cat-joint-stiffness-treatment"
  },
  {
    "name": "cat hip arthritis management",
    "slug": "cat-hip-arthritis-management"
  },
  {
    "name": "cat arthritis treatment options",
    "slug": "cat-arthritis-treatment-options"
  },
  {
    "name": "feline joint health care",
    "slug": "feline-joint-health-care"
  },
  {
    "name": "feline hip pain relief",
    "slug": "feline-hip-pain-relief"
  },
  {
    "name": "feline arthritis treatment options",
    "slug": "feline-arthritis-treatment-options"
  },
  {
    "name": "cat joint pain management",
    "slug": "cat-joint-pain-management"
  },
  {
    "name": "cat hip joint care",
    "slug": "cat-hip-joint-care"
  },
  {
    "name": "cat arthritis natural remedies",
    "slug": "cat-arthritis-natural-remedies"
  },
  {
    "name": "feline joint inflammation treatment",
    "slug": "feline-joint-inflammation-treatment"
  },
  {
    "name": "feline hip joint issues",
    "slug": "feline-hip-joint-issues"
  },
  {
    "name": "feline arthritis support supplements",
    "slug": "feline-arthritis-support-supplements"
  },
  {
    "name": "cat joint pain causes",
    "slug": "cat-joint-pain-causes"
  },
  {
    "name": "cat hip dysplasia management",
    "slug": "cat-hip-dysplasia-management"
  },
  {
    "name": "cat arthritis pain relief",
    "slug": "cat-arthritis-pain-relief"
  },
  {
    "name": "feline joint stiffness treatment",
    "slug": "feline-joint-stiffness-treatment"
  },
  {
    "name": "feline hip arthritis management",
    "slug": "feline-hip-arthritis-management"
  },
  {
    "name": "feline arthritis treatment options",
    "slug": "feline-arthritis-treatment-options"
  },
  {
    "name": "cat joint health care",
    "slug": "cat-joint-health-care"
  },
  {
    "name": "cat hip pain relief",
    "slug": "cat-hip-pain-relief"
  },
  {
    "name": "cat arthritis treatment options",
    "slug": "cat-arthritis-treatment-options"
  },
  {
    "name": "feline joint pain management",
    "slug": "feline-joint-pain-management"
  },
  {
    "name": "feline hip joint care",
    "slug": "feline-hip-joint-care"
  },
  {
    "name": "feline arthritis natural remedies",
    "slug": "feline-arthritis-natural-remedies"
  },
  {
    "name": "cat joint inflammation treatment",
    "slug": "cat-joint-inflammation-treatment"
  },
  {
    "name": "cat hip joint issues",
    "slug": "cat-hip-joint-issues"
  },
  {
    "name": "cat arthritis support supplements",
    "slug": "cat-arthritis-support-supplements"
  },
  {
    "name": "feline joint pain causes",
    "slug": "feline-joint-pain-causes"
  },
  {
    "name": "feline hip dysplasia management",
    "slug": "feline-hip-dysplasia-management"
  },
  {
    "name": "feline arthritis pain relief",
    "slug": "feline-arthritis-pain-relief"
  },
  {
    "name": "cat joint stiffness treatment",
    "slug": "cat-joint-stiffness-treatment"
  },
  {
    "name": "cat hip arthritis management",
    "slug": "cat-hip-arthritis-management"
  },
  {
    "name": "cat arthritis treatment options",
    "slug": "cat-arthritis-treatment-options"
  },
  {
    "name": "feline joint health care",
    "slug": "feline-joint-health-care"
  },
  {
    "name": "feline hip pain relief",
    "slug": "feline-hip-pain-relief"
  },
  {
    "name": "feline arthritis treatment options",
    "slug": "feline-arthritis-treatment-options"
  },
  {
    "name": "cat joint pain management",
    "slug": "cat-joint-pain-management"
  },
  {
    "name": "cat hip joint care",
    "slug": "cat-hip-joint-care"
  },
  {
    "name": "cat arthritis natural remedies",
    "slug": "cat-arthritis-natural-remedies"
  },
  {
    "name": "feline joint inflammation treatment",
    "slug": "feline-joint-inflammation-treatment"
  },
  {
    "name": "feline hip joint issues",
    "slug": "feline-hip-joint-issues"
  },
  {
    "name": "feline arthritis support supplements",
    "slug": "feline-arthritis-support-supplements"
  },
  {
    "name": "cat joint pain causes",
    "slug": "cat-joint-pain-causes"
  },
  {
    "name": "cat hip dysplasia management",
    "slug": "cat-hip-dysplasia-management"
  },
  {
    "name": "cat arthritis pain relief",
    "slug": "cat-arthritis-pain-relief"
  },
  {
    "name": "feline joint stiffness treatment",
    "slug": "feline-joint-stiffness-treatment"
  },
  {
    "name": "feline hip arthritis management",
    "slug": "feline-hip-arthritis-management"
  },
  {
    "name": "feline arthritis treatment options",
    "slug": "feline-arthritis-treatment-options"
  },
  {
    "name": "cat joint health care",
    "slug": "cat-joint-health-care"
  },
  {
    "name": "cat hip pain relief",
    "slug": "cat-hip-pain-relief"
  },
  {
    "name": "cat arthritis treatment options",
    "slug": "cat-arthritis-treatment-options"
  },
  {
    "name": "feline joint pain management",
    "slug": "feline-joint-pain-management"
  },
  {
    "name": "feline hip joint care",
    "slug": "feline-hip-joint-care"
  },
  {
    "name": "feline arthritis natural remedies",
    "slug": "feline-arthritis-natural-remedies"
  },
  {
    "name": "cat joint inflammation treatment",
    "slug": "cat-joint-inflammation-treatment"
  },
  {
    "name": "cat hip joint issues",
    "slug": "cat-hip-joint-issues"
  },
  {
    "name": "cat arthritis support supplements",
    "slug": "cat-arthritis-support-supplements"
  },
  {
    "name": "feline joint pain causes",
    "slug": "feline-joint-pain-causes"
  },
  {
    "name": "feline hip dysplasia management",
    "slug": "feline-hip-dysplasia-management"
  },
  {
    "name": "feline arthritis pain relief",
    "slug": "feline-arthritis-pain-relief"
  },
  {
    "name": "cat joint stiffness treatment",
    "slug": "cat-joint-stiffness-treatment"
  },
  {
    "name": "cat hip arthritis management",
    "slug": "cat-hip-arthritis-management"
  },
  {
    "name": "cat arthritis treatment options",
    "slug": "cat-arthritis-treatment-options"
  },
  {
    "name": "feline joint health care",
    "slug": "feline-joint-health-care"
  },
  {
    "name": "feline hip pain relief",
    "slug": "feline-hip-pain-relief"
  },
  {
    "name": "feline arthritis treatment options",
    "slug": "feline-arthritis-treatment-options"
  },
  {
    "name": "cat joint pain management",
    "slug": "cat-joint-pain-management"
  },
  {
    "name": "cat skin conditions",
    "slug": "cat-skin-conditions"
  },
  {
    "name": "cat skin infections",
    "slug": "cat-skin-infections"
  },
  {
    "name": "cat skin allergies",
    "slug": "cat-skin-allergies"
  },
  {
    "name": "cat skin problems",
    "slug": "cat-skin-problems"
  },
  {
    "name": "cat skin dermatitis",
    "slug": "cat-skin-dermatitis"
  },
  {
    "name": "cat skin issues",
    "slug": "cat-skin-issues"
  },
  {
    "name": "cat skin rashes",
    "slug": "cat-skin-rashes"
  },
  {
    "name": "cat skin diseases",
    "slug": "cat-skin-diseases"
  },
  {
    "name": "cat skin irritation",
    "slug": "cat-skin-irritation"
  },
  {
    "name": "cat skin bumps",
    "slug": "cat-skin-bumps"
  },
  {
    "name": "cat skin sores",
    "slug": "cat-skin-sores"
  },
  {
    "name": "cat skin lesions",
    "slug": "cat-skin-lesions"
  },
  {
    "name": "cat skin scabs",
    "slug": "cat-skin-scabs"
  },
  {
    "name": "cat skin fungus",
    "slug": "cat-skin-fungus"
  },
  {
    "name": "cat skin disorders",
    "slug": "cat-skin-disorders"
  },
  {
    "name": "cat skin parasites",
    "slug": "cat-skin-parasites"
  },
  {
    "name": "cat skin mites",
    "slug": "cat-skin-mites"
  },
  {
    "name": "cat skin lumps",
    "slug": "cat-skin-lumps"
  },
  {
    "name": "cat skin redness",
    "slug": "cat-skin-redness"
  },
  {
    "name": "cat skin scaling",
    "slug": "cat-skin-scaling"
  },
  {
    "name": "cat skin crusts",
    "slug": "cat-skin-crusts"
  },
  {
    "name": "cat skin ulcers",
    "slug": "cat-skin-ulcers"
  },
  {
    "name": "cat skin tags",
    "slug": "cat-skin-tags"
  },
  {
    "name": "cat skin nodules",
    "slug": "cat-skin-nodules"
  },
  {
    "name": "cat skin masses",
    "slug": "cat-skin-masses"
  },
  {
    "name": "cat skin swelling",
    "slug": "cat-skin-swelling"
  },
  {
    "name": "cat skin peeling",
    "slug": "cat-skin-peeling"
  },
  {
    "name": "cat skin flaking",
    "slug": "cat-skin-flaking"
  },
  {
    "name": "cat skin patches",
    "slug": "cat-skin-patches"
  },
  {
    "name": "cat skin blisters",
    "slug": "cat-skin-blisters"
  },
  {
    "name": "cat skin cysts",
    "slug": "cat-skin-cysts"
  },
  {
    "name": "cat skin pigmentation",
    "slug": "cat-skin-pigmentation"
  },
  {
    "name": "cat skin thickening",
    "slug": "cat-skin-thickening"
  },
  {
    "name": "cat skin tenderness",
    "slug": "cat-skin-tenderness"
  },
  {
    "name": "cat skin sensitivity",
    "slug": "cat-skin-sensitivity"
  },
  {
    "name": "cat skin odor",
    "slug": "cat-skin-odor"
  },
  {
    "name": "cat skin dryness",
    "slug": "cat-skin-dryness"
  },
  {
    "name": "cat skin greasiness",
    "slug": "cat-skin-greasiness"
  },
  {
    "name": "cat skin oiliness",
    "slug": "cat-skin-oiliness"
  },
  {
    "name": "cat skin inflammation",
    "slug": "cat-skin-inflammation"
  },
  {
    "name": "cat skin depigmentation",
    "slug": "cat-skin-depigmentation"
  },
  {
    "name": "cat skin hyperpigmentation",
    "slug": "cat-skin-hyperpigmentation"
  },
  {
    "name": "cat skin fragility",
    "slug": "cat-skin-fragility"
  },
  {
    "name": "cat skin elasticity",
    "slug": "cat-skin-elasticity"
  },
  {
    "name": "cat skin texture",
    "slug": "cat-skin-texture"
  },
  {
    "name": "cat skin moisture",
    "slug": "cat-skin-moisture"
  },
  {
    "name": "cat skin balance",
    "slug": "cat-skin-balance"
  },
  {
    "name": "cat skin flora",
    "slug": "cat-skin-flora"
  },
  {
    "name": "cat skin microbiome",
    "slug": "cat-skin-microbiome"
  },
  {
    "name": "cat skin health",
    "slug": "cat-skin-health"
  },
  {
    "name": "cat glaucoma symptoms",
    "slug": "cat-glaucoma-symptoms"
  },
  {
    "name": "cat glaucoma treatment",
    "slug": "cat-glaucoma-treatment"
  },
  {
    "name": "cat glaucoma medication",
    "slug": "cat-glaucoma-medication"
  },
  {
    "name": "cat glaucoma management",
    "slug": "cat-glaucoma-management"
  },
  {
    "name": "cat glaucoma prevention",
    "slug": "cat-glaucoma-prevention"
  },
  {
    "name": "cat glaucoma diagnosis",
    "slug": "cat-glaucoma-diagnosis"
  },
  {
    "name": "cat glaucoma surgery",
    "slug": "cat-glaucoma-surgery"
  },
  {
    "name": "cat glaucoma prognosis",
    "slug": "cat-glaucoma-prognosis"
  },
  {
    "name": "cat glaucoma causes",
    "slug": "cat-glaucoma-causes"
  },
  {
    "name": "cat glaucoma therapy",
    "slug": "cat-glaucoma-therapy"
  },
  {
    "name": "cat glaucoma progression",
    "slug": "cat-glaucoma-progression"
  },
  {
    "name": "cat glaucoma eye drops",
    "slug": "cat-glaucoma-eye-drops"
  },
  {
    "name": "cat glaucoma complications",
    "slug": "cat-glaucoma-complications"
  },
  {
    "name": "cat glaucoma pressure",
    "slug": "cat-glaucoma-pressure"
  },
  {
    "name": "cat glaucoma blindness",
    "slug": "cat-glaucoma-blindness"
  },
  {
    "name": "cat glaucoma monitoring",
    "slug": "cat-glaucoma-monitoring"
  },
  {
    "name": "cat glaucoma vision",
    "slug": "cat-glaucoma-vision"
  },
  {
    "name": "cat glaucoma risks",
    "slug": "cat-glaucoma-risks"
  },
  {
    "name": "cat glaucoma detection",
    "slug": "cat-glaucoma-detection"
  },
  {
    "name": "cat glaucoma care",
    "slug": "cat-glaucoma-care"
  },
  {
    "name": "cat yeast infection",
    "slug": "cat-yeast-infection"
  },
  {
    "name": "feline yeast infection",
    "slug": "feline-yeast-infection"
  },
  {
    "name": "yeast infection cats",
    "slug": "yeast-infection-cats"
  },
  {
    "name": "yeast infection feline",
    "slug": "yeast-infection-feline"
  },
  {
    "name": "cat yeast symptoms",
    "slug": "cat-yeast-symptoms"
  },
  {
    "name": "yeast infection remedies",
    "slug": "yeast-infection-remedies"
  },
  {
    "name": "cat yeast treatment",
    "slug": "cat-yeast-treatment"
  },
  {
    "name": "yeast infection causes",
    "slug": "yeast-infection-causes"
  },
  {
    "name": "cat yeast issues",
    "slug": "cat-yeast-issues"
  },
  {
    "name": "yeast infection feline skin",
    "slug": "yeast-infection-feline-skin"
  },
  {
    "name": "cat yeast solutions",
    "slug": "cat-yeast-solutions"
  },
  {
    "name": "feline yeast problems",
    "slug": "feline-yeast-problems"
  },
  {
    "name": "cat yeast management",
    "slug": "cat-yeast-management"
  },
  {
    "name": "yeast infection control",
    "slug": "yeast-infection-control"
  },
  {
    "name": "feline yeast treatment",
    "slug": "feline-yeast-treatment"
  },
  {
    "name": "yeast infection relief",
    "slug": "yeast-infection-relief"
  },
  {
    "name": "yeast infection feline ears",
    "slug": "yeast-infection-feline-ears"
  },
  {
    "name": "yeast infection prevention",
    "slug": "yeast-infection-prevention"
  },
  {
    "name": "cat yeast odor",
    "slug": "cat-yeast-odor"
  },
  {
    "name": "yeast infection diagnosis",
    "slug": "yeast-infection-diagnosis"
  },
  {
    "name": "feline skin infection treatment",
    "slug": "feline-skin-infection-treatment"
  },
  {
    "name": "feline skin allergy symptoms",
    "slug": "feline-skin-allergy-symptoms"
  },
  {
    "name": "feline skin problem remedies",
    "slug": "feline-skin-problem-remedies"
  },
  {
    "name": "feline skin condition management",
    "slug": "feline-skin-condition-management"
  },
  {
    "name": "feline skin disease prevention",
    "slug": "feline-skin-disease-prevention"
  },
  {
    "name": "feline skin irritation relief",
    "slug": "feline-skin-irritation-relief"
  },
  {
    "name": "feline skin rash causes",
    "slug": "feline-skin-rash-causes"
  },
  {
    "name": "feline skin disorder diagnosis",
    "slug": "feline-skin-disorder-diagnosis"
  },
  {
    "name": "feline skin lesion identification",
    "slug": "feline-skin-lesion-identification"
  },
  {
    "name": "feline skin scab healing",
    "slug": "feline-skin-scab-healing"
  },
  {
    "name": "feline skin fungus treatment",
    "slug": "feline-skin-fungus-treatment"
  },
  {
    "name": "feline skin parasite control",
    "slug": "feline-skin-parasite-control"
  },
  {
    "name": "feline skin mite infestation",
    "slug": "feline-skin-mite-infestation"
  },
  {
    "name": "feline skin lump evaluation",
    "slug": "feline-skin-lump-evaluation"
  },
  {
    "name": "feline skin redness causes",
    "slug": "feline-skin-redness-causes"
  },
  {
    "name": "feline skin scaling treatment",
    "slug": "feline-skin-scaling-treatment"
  },
  {
    "name": "feline skin crust removal",
    "slug": "feline-skin-crust-removal"
  },
  {
    "name": "feline skin ulcer care",
    "slug": "feline-skin-ulcer-care"
  },
  {
    "name": "feline skin tag removal",
    "slug": "feline-skin-tag-removal"
  },
  {
    "name": "feline skin nodule assessment",
    "slug": "feline-skin-nodule-assessment"
  },
  {
    "name": "feline skin mass biopsy",
    "slug": "feline-skin-mass-biopsy"
  },
  {
    "name": "feline skin swelling causes",
    "slug": "feline-skin-swelling-causes"
  },
  {
    "name": "feline skin peeling treatment",
    "slug": "feline-skin-peeling-treatment"
  },
  {
    "name": "feline skin flaking remedies",
    "slug": "feline-skin-flaking-remedies"
  },
  {
    "name": "feline skin patch diagnosis",
    "slug": "feline-skin-patch-diagnosis"
  },
  {
    "name": "feline skin blister care",
    "slug": "feline-skin-blister-care"
  },
  {
    "name": "feline skin cyst removal",
    "slug": "feline-skin-cyst-removal"
  },
  {
    "name": "feline skin pigmentation changes",
    "slug": "feline-skin-pigmentation-changes"
  },
  {
    "name": "feline skin thickening causes",
    "slug": "feline-skin-thickening-causes"
  },
  {
    "name": "feline skin tenderness relief",
    "slug": "feline-skin-tenderness-relief"
  },
  {
    "name": "feline skin sensitivity management",
    "slug": "feline-skin-sensitivity-management"
  },
  {
    "name": "feline skin odor treatment",
    "slug": "feline-skin-odor-treatment"
  },
  {
    "name": "feline skin dryness remedies",
    "slug": "feline-skin-dryness-remedies"
  },
  {
    "name": "feline skin greasiness control",
    "slug": "feline-skin-greasiness-control"
  },
  {
    "name": "feline skin oiliness management",
    "slug": "feline-skin-oiliness-management"
  },
  {
    "name": "feline skin inflammation causes",
    "slug": "feline-skin-inflammation-causes"
  },
  {
    "name": "feline skin depigmentation treatment",
    "slug": "feline-skin-depigmentation-treatment"
  },
  {
    "name": "feline skin hyperpigmentation remedies",
    "slug": "feline-skin-hyperpigmentation-remedies"
  },
  {
    "name": "feline skin fragility management",
    "slug": "feline-skin-fragility-management"
  },
  {
    "name": "feline skin elasticity improvement",
    "slug": "feline-skin-elasticity-improvement"
  },
  {
    "name": "feline skin texture enhancement",
    "slug": "feline-skin-texture-enhancement"
  },
  {
    "name": "feline skin moisture balance",
    "slug": "feline-skin-moisture-balance"
  },
  {
    "name": "feline skin flora restoration",
    "slug": "feline-skin-flora-restoration"
  },
  {
    "name": "feline skin microbiome health",
    "slug": "feline-skin-microbiome-health"
  },
  {
    "name": "feline skin health maintenance",
    "slug": "feline-skin-health-maintenance"
  },
  {
    "name": "cat glaucoma symptoms",
    "slug": "cat-glaucoma-symptoms"
  },
  {
    "name": "cat glaucoma treatment",
    "slug": "cat-glaucoma-treatment"
  },
  {
    "name": "cat glaucoma surgery",
    "slug": "cat-glaucoma-surgery"
  },
  {
    "name": "cat glaucoma medication",
    "slug": "cat-glaucoma-medication"
  },
  {
    "name": "cat glaucoma management",
    "slug": "cat-glaucoma-management"
  },
  {
    "name": "cat glaucoma diagnosis",
    "slug": "cat-glaucoma-diagnosis"
  },
  {
    "name": "cat glaucoma causes",
    "slug": "cat-glaucoma-causes"
  },
  {
    "name": "cat glaucoma prevention",
    "slug": "cat-glaucoma-prevention"
  },
  {
    "name": "cat glaucoma prognosis",
    "slug": "cat-glaucoma-prognosis"
  },
  {
    "name": "cat glaucoma progression",
    "slug": "cat-glaucoma-progression"
  },
  {
    "name": "cat glaucoma blindness",
    "slug": "cat-glaucoma-blindness"
  },
  {
    "name": "cat glaucoma pressure",
    "slug": "cat-glaucoma-pressure"
  },
  {
    "name": "cat glaucoma testing",
    "slug": "cat-glaucoma-testing"
  },
  {
    "name": "cat glaucoma therapy",
    "slug": "cat-glaucoma-therapy"
  },
  {
    "name": "cat glaucoma care",
    "slug": "cat-glaucoma-care"
  },
  {
    "name": "cat glaucoma monitoring",
    "slug": "cat-glaucoma-monitoring"
  },
  {
    "name": "cat glaucoma complications",
    "slug": "cat-glaucoma-complications"
  },
  {
    "name": "cat glaucoma risk factors",
    "slug": "cat-glaucoma-risk-factors"
  },
  {
    "name": "cat glaucoma signs",
    "slug": "cat-glaucoma-signs"
  },
  {
    "name": "cat glaucoma eye drops",
    "slug": "cat-glaucoma-eye-drops"
  },
  {
    "name": "cat glaucoma laser surgery",
    "slug": "cat-glaucoma-laser-surgery"
  },
  {
    "name": "cat glaucoma veterinary specialist",
    "slug": "cat-glaucoma-veterinary-specialist"
  },
  {
    "name": "cat glaucoma eye exam",
    "slug": "cat-glaucoma-eye-exam"
  },
  {
    "name": "cat glaucoma intraocular pressure",
    "slug": "cat-glaucoma-intraocular-pressure"
  },
  {
    "name": "cat glaucoma optic nerve",
    "slug": "cat-glaucoma-optic-nerve"
  },
  {
    "name": "cat glaucoma vision loss",
    "slug": "cat-glaucoma-vision-loss"
  },
  {
    "name": "cat glaucoma early detection",
    "slug": "cat-glaucoma-early-detection"
  },
  {
    "name": "cat glaucoma treatment options",
    "slug": "cat-glaucoma-treatment-options"
  },
  {
    "name": "cat glaucoma medical management",
    "slug": "cat-glaucoma-medical-management"
  },
  {
    "name": "cat glaucoma surgical intervention",
    "slug": "cat-glaucoma-surgical-intervention"
  },
  {
    "name": "cat glaucoma disease progression",
    "slug": "cat-glaucoma-disease-progression"
  },
  {
    "name": "cat glaucoma quality of life",
    "slug": "cat-glaucoma-quality-of-life"
  },
  {
    "name": "cat glaucoma eye health",
    "slug": "cat-glaucoma-eye-health"
  },
  {
    "name": "cat glaucoma clinical signs",
    "slug": "cat-glaucoma-clinical-signs"
  },
  {
    "name": "cat glaucoma diagnostic tests",
    "slug": "cat-glaucoma-diagnostic-tests"
  },
  {
    "name": "cat glaucoma therapeutic approaches",
    "slug": "cat-glaucoma-therapeutic-approaches"
  },
  {
    "name": "cat glaucoma patient monitoring",
    "slug": "cat-glaucoma-patient-monitoring"
  },
  {
    "name": "cat glaucoma potential complications",
    "slug": "cat-glaucoma-potential-complications"
  },
  {
    "name": "cat glaucoma underlying causes",
    "slug": "cat-glaucoma-underlying-causes"
  },
  {
    "name": "cat glaucoma preventive measures",
    "slug": "cat-glaucoma-preventive-measures"
  },
  {
    "name": "cat glaucoma disease management",
    "slug": "cat-glaucoma-disease-management"
  },
  {
    "name": "cat glaucoma treatment outcomes",
    "slug": "cat-glaucoma-treatment-outcomes"
  },
  {
    "name": "cat glaucoma veterinary care",
    "slug": "cat-glaucoma-veterinary-care"
  },
  {
    "name": "cat glaucoma ocular health",
    "slug": "cat-glaucoma-ocular-health"
  },
  {
    "name": "cat glaucoma symptom recognition",
    "slug": "cat-glaucoma-symptom-recognition"
  },
  {
    "name": "cat glaucoma disease awareness",
    "slug": "cat-glaucoma-disease-awareness"
  },
  {
    "name": "cat glaucoma owner education",
    "slug": "cat-glaucoma-owner-education"
  },
  {
    "name": "cat glaucoma supportive care",
    "slug": "cat-glaucoma-supportive-care"
  },
  {
    "name": "cat glaucoma long-term management",
    "slug": "cat-glaucoma-long-term-management"
  },
  {
    "name": "cat glaucoma prognosis factors",
    "slug": "cat-glaucoma-prognosis-factors"
  },
  {
    "name": "cat glaucoma treatment adherence",
    "slug": "cat-glaucoma-treatment-adherence"
  },
  {
    "name": "cat glaucoma follow-up care",
    "slug": "cat-glaucoma-follow-up-care"
  },
  {
    "name": "cat glaucoma patient support",
    "slug": "cat-glaucoma-patient-support"
  },
  {
    "name": "cat glaucoma research updates",
    "slug": "cat-glaucoma-research-updates"
  },
  {
    "name": "cat glaucoma treatment advancements",
    "slug": "cat-glaucoma-treatment-advancements"
  }
];
/**
 * Obtains a random word from the word array.
 * @returns {Object} An object with the name and slug of a random word.
 */
function getRandomWord() {
  const randomIndex = Math.floor(Math.random() * words.length);
  return words[randomIndex];
}

/**
 * Gets the slug of a random word.
 * @returns {String} The slug of a random word.
 */
function getRandomWordSlug() {
  const randomWord = getRandomWord();
  return randomWord.slug;
}

/**
 * Gets the name of a random word.
 * @returns {String} The name of a random word.
 */
function getRandomWordName() {
  const randomWord = getRandomWord();
  return randomWord.name;
}
// Make features globally accessible
window.getRandomWord = getRandomWord;
window.getRandomWordSlug = getRandomWordSlug;
window.getRandomWordName = getRandomWordName;